<template>
  <div class="protocol">
    <div id="wrapper" v-if="type == 1">
      <div class="layout">
        <div class="protocol-box">
          <h1 style="text-align: center">掌門用戶註冊協議</h1>
          <div class="title">
            <p style="text-align: left; color: #999999">
              版本更新日期：2020年9月23日
            </p>
            <p style="text-align: left; color: #999999">
              本政策生效日期：2018年9月17日
            </p>
            <p style="text-align: left; color: #999999">版本號：2020 v 2.4.1</p>
          </div>
          <p>
            歡迎使用掌門教育/掌門新銳在線教育服務，在使用掌門教育/掌門新銳之前請您仔細閱讀本用戶協議。掌門教育/掌門新銳感謝您的支持和信任！
          </p>
          <p>
            掌門教育/掌門新銳提示您：閱讀本協議的過程中，如果您不同意本協議或其中任何條款約定，您應立即停止註冊程序。如您未申請註冊流程，您仍可瀏覽網站或APP或相關鏈接頁面內容但無法通過賬號註冊獲得掌門教育/掌門新銳的課程服務。
          </p>
          <p class="bold">
            如果您在本協議生效前已成為掌門教育/掌門新銳平臺的註冊用戶，則您通過訪問和/或使用掌門教育/掌門新銳平臺網站、客戶端（含APP/APK/SDK/API方式）、內容分發、信息網絡傳播等方式在內的各種形態（包括未來技術發展出現新的服務形態），即視為您表示同意接受本協議的全部內容，否則請您不要訪問或接受掌門教育/掌門新銳平臺服務。
          </p>
          <div class="protocol-page">
            <h2>一、註冊協議條款的確認和接受</h2>
            <p>
              本用戶協議雙方分別為“上海掌小門教育科技有限公司/深圳掌門人教育咨詢有限公司”、及其關聯公司（以下稱“掌門教育/掌門新銳”）和“掌門教育/掌門新銳用戶”，本用戶協議具有合同效力。
            </p>
            <p>
              掌門教育/掌門新銳(以下亦稱“本網站”)同意按照本協議的規定及其不定時發布的操作規則提供基於互聯網和移動網的相關服務(以下稱“網絡服務”)。
            </p>
            <p>
              本協議為掌門教育/掌門新銳用戶註冊協議（以下稱“《協議》”），<span
                class="bold"
                >為獲得網絡服務,申請人應當認真閱讀、充分理解本《協議》中各條款,包括免除或者限制掌門教育/掌門新銳責任的免責條款及對用戶的權利限制條款。審慎閱讀並選擇接受或不接受本《協議》(未成年人應在法定監護人陪同下閱讀，並在提交個人信息之前尋求父母或監護人的同意和指導。)。</span
              >
            </p>
            <p class="bold">
              同意接受本《協議》的全部條款的,申請人應當按照頁面上的提示完成全部的註冊程序,並在註冊程序過程中點擊“註冊”按鈕,否則視為不接受本《協議》全部條款,申請人應當終止並退出申請。
            </p>
            <p>
              用戶註冊成功後，掌門教育/掌門新銳將給予每個用戶一個用戶帳號及相應的密碼，該用戶帳號和密碼由用戶負責保管；用戶應當對以其用戶帳號進行的所有活動和事件負法律責任。用戶註冊成功，掌門教育/掌門新銳將會向每位註冊用戶撥打電話進一步介紹本公司的相關服務情況。
              <span class="bold">
                用戶的註冊行為即視同為同意接受公司進一步的電話服務。</span
              >
            </p>
            <p>
              掌門教育/掌門新銳有權對用戶使用掌門教育/掌門新銳網絡服務的情況進行審查和監督(包括但不限於對用戶存儲在掌門教育/掌門新銳的內容進行審核)，如用戶在使用網絡服務時違反任何上述規定，掌門教育/掌門新銳或其授權的人有權要求用戶改正或直接采取一切必要的措施（包括但不限於更改或刪除用戶張貼的內容等、暫停或終止用戶使用網絡服務的權利）以減輕用戶不當行為造成的影響。
            </p>
            <p class="bold">
              掌門教育/掌門新銳針對某些特定的掌門教育/掌門新銳網絡服務的使用通過各種方式（包括但不限於網頁公告、電子郵件、短信提醒等）作出的任何聲明、通知、警示等內容視為本《協議》的一部分，用戶如使用該等掌門教育/掌門新銳網絡服務，視為用戶同意該等聲明、通知、警示的內容。
            </p>
            <p>
              本《協議》可由掌門教育/掌門新銳不定時更新，如本《協議》有任何變更，掌門教育/掌門新銳將在網站上刊載公告，通知予用戶。經修訂的協議一經在掌門教育/掌門新銳官網公布後，立即自動生效。<span
                class="bold"
              >
                在本網站修改《協議》條款後,如果用戶不接受修改後的條款,請立即停止使用本網站提供的網絡服務,繼續使用的用戶將被視為已接受了修改後的協議。</span
              >
            </p>
          </div>
          <div class="protocol-page">
            <h2>二、定義</h2>
            <p>
              用戶及用戶註冊：用戶必須是具備完全民事行為能力的自然人。用戶註冊是指用戶登錄掌門教育/掌門新銳官網，並按要求填寫相關信息並確認同意履行《協議》的過程。用戶因進行交易、獲取有償服務所有應納稅賦，以及一切硬件、軟件、服務及其它方面的費用均由用戶負責支付。掌門教育/掌門新銳僅作為網絡教育培訓平臺。
            </p>
          </div>
          <div class="protocol-page">
            <h2>三、掌門教育/掌門新銳的權利和義務</h2>
            <p>
              1、掌門教育/掌門新銳有義務在現有技術上維護整個網絡教育平臺的正常運行，並努力提升和改進技術，使用戶網絡教育活動得以順利進行；
            </p>
            <p>
              2、對用戶在註冊使用掌門教育/掌門新銳網絡教育平臺中所遇到的與交易或註冊有關的問題及反映的情況，掌門教育/掌門新銳應及時作出回復；
            </p>
            <p>
              <span class="bold"
                >3、對於用戶在掌門教育/掌門新銳網絡教育平臺上的不當行為或其它任何掌門教育/掌門新銳認為應當終止服務的情況，掌門教育/掌門新銳有權隨時作出刪除相關信息、終止服務提供等處理，而無須征得用戶的同意；</span
              >掌門教育/掌門新銳應本著誠實信用的原則向用戶提供遠程教育服務，不得隨意中斷或停止提供該項服務。<span
                class="bold"
                >但由於不可抗力或者其它非人為因素造成的服務的中斷或停止，掌門教育/掌門新銳不承擔任何相應的責任。</span
              >
            </p>
            <p>
              4、掌門教育/掌門新銳享有對用戶網上活動的監督和指導權，對凡是從事網上非法活動的用戶，有權終止所有服務。
            </p>
          </div>
          <div class="protocol-page">
            <h2>四、用戶的權利和義務</h2>
            <p>1、所有用戶必須遵循：</p>
            <p>（1）遵守所有使用網絡服務的網絡協議、規定、程序和慣例；</p>
            <p>（2）不得使用掌門教育/掌門新銳網絡教育平臺從事違法活動；</p>
            <p>
              （3）不得幹擾或侵犯掌門教育/掌門新銳的正常運行和其他用戶的正常使用；
            </p>
            <p>（4）用戶購買的課程只允許個人使用，不能用於其他目的；</p>
            <p>
              （5）從中國境內向境外傳輸技術性資料時不得違反中國有關法律、法規。
            </p>
            <p>2、同時用戶承諾：</p>
            <p>
              （1）不得利用掌門教育/掌門新銳在線網絡教育平臺制作、復制、查閱和傳播下列信息：
            </p>
            <p>
              任何非法的、騷擾性的、中傷他人的、辱罵性的、恐嚇性的、傷害性的、庸俗的、淫穢的信息資料；
            </p>
            <p>—任何教唆他人進行違法犯罪行為的資料；</p>
            <p>—不利於國內團結和社會安定的資料；</p>
            <p>—任何不符合國家法律、法規規定的資料、信息；</p>
            <p>—任何捏造或者歪曲事實，散布謠言，擾亂社會秩序的信息；</p>
            <p>—損害掌門教育/掌門新銳在線教育的聲譽和商業利益的信息；</p>
            <p>（2）不得未經許可而非法進入其它個人或組織電腦系統；</p>
            <p>
              （3）未經允許，不得對掌門教育/掌門新銳在線網絡教育平臺中存儲、處理或者傳輸的數據和應用程序進行刪除、修改或者增加；
            </p>
            <p>（4）不得故意制作、傳播計算機病毒等破壞性程序；</p>
            <p>（5）法律規定的其他義務。</p>
            <p>
              如果用戶的行為違背上述兩款規定，掌門教育/掌門新銳可以做出獨立判斷並有權立即取消用戶資格。用戶應對自己在掌門教育/掌門新銳網絡教育平臺上的違法行為承擔全部法律責任。
            </p>
            <p>3、基於網絡服務的特殊性，用戶同意：</p>
            <p>（1）在註冊時按照註冊提示提供準確用戶名和密碼以及聯系方式；</p>
            <p>
              （2）在個人的註冊信息發生變化時，用戶應及時更新自己的註冊信息，保證其個人資料的詳盡和準確。所有用戶輸入的個人信息將被視作準確表明了用戶的身份，並作為掌門教育/掌門新銳提供所有服務的有效身份依據。
            </p>
            <p>
              （3）用戶自行配備上網的所需設備，包括個人電腦、調制解調器或其他必備上網裝置；
            </p>
            <p>
              （4）用戶應自行負擔因使用這種接入方式而產生的上網電話費、上網信息費及教育信息費。
            </p>
            <p>4、用戶的用戶名、密碼。</p>
            <p>
              （1）用戶一旦註冊成功，成為掌門教育/掌門新銳的正式用戶後，應當對自己的用戶名（亦稱帳號）、密碼的安全性負全部責任。用戶的密碼只能由用戶自己掌握。<span
                class="bold"
                >對於用戶因帳號或密碼泄露造成的各種損失，掌門教育/掌門新銳在線不承擔任何責任。</span
              >用戶發現任何非法使用用戶帳號的情況，應立即通知本網站。<span
                class="bold"
                >因黑客行為或用戶的保管疏忽導致帳號、密碼遭他人非法使用，掌門教育/掌門新銳不承擔任何責任。</span
              >
            </p>
            <p>
              （2）對於用戶通過掌門教育/掌門新銳網絡服務（包括但不限於論壇、BBS、教育問答）上傳到掌門教育/掌門新銳網站上可公開獲取區域的任何內容，用戶同意掌門教育/掌門新銳在全世界範圍內具有免費的、永久性的、不可撤銷的、非獨家的和完全再許可的權利和許可，以使用、復制、修改、改編、出版、翻譯、據以創作衍生作品、傳播、表演和展示此等內容（整體或部分），和/或將此等內容編入當前已知的或以後開發的其他任何形式的作品、媒體或技術中。
            </p>
            <p>（3）確保您在每個上網時段結束時，以正確步驟離開網站/服務。</p>
            <p>
              （4）掌門教育/掌門新銳不能也不會對因您未能遵守本款規定而發生的任何損失負責。用戶應對以其用戶名進行的所有活動和事件負責。
            </p>
          </div>
          <div class="protocol-page">
            <h2>五、版權聲明</h2>
            <p>
              本網站提供的網絡服務中包含的任何文本、圖片、圖形、音頻和/或視頻資料均受版權、商標和/或其它財產所有權法律的保護,未經相關權利人同意,上述資料均不得在任何媒體直接或間接發布、播放、出於播放或發布目的而改寫或再發行,或者被用於其他任何商業目的。所有以上資料或資料的任何部分僅可作為私人和非商業用途保存。<span
                class="bold"
                >本網站不就由上述資料產生或在傳送或遞交全部或部分上述資料過程中產生的延誤、不準確、錯誤和遺漏或從中產生或由此產生的任何損害賠償,以任何形式,向用戶或任何第三方負責。</span
              >
            </p>
          </div>
          <div class="protocol-page">
            <h2>六、法律管轄</h2>
            <p>
              1、本《協議》的訂立、執行和解釋及爭議的解決均應適用中國法律並受中國法院管轄。
            </p>
            <p>
              2、如雙方就本《協議》內容或其執行發生任何爭議，雙方應盡量友好協商解決；協商不成時，任何一方均可向掌門教育/掌門新銳所在地的人民法院提起訴訟。
            </p>
          </div>
          <div class="protocol-page">
            <h2>七、知識產權</h2>
            <p>
              掌門教育/掌門新銳對掌門教育/掌門新銳專有內容、原創內容和其他通過授權取得的獨占或獨家內容享有完全知識產權。未經掌門教育/掌門新銳許可，任何單位和個人不得私自轉載、傳播或者有其他侵犯掌門教育/掌門新銳知識產權的行為，否則將承擔所有相關的法律責任。
            </p>
          </div>
          <div class="protocol-page">
            <h2>八、協議的終止</h2>
            <p>您有權通過以下方式終止本《協議》：</p>
            <p>
              在履行完畢所有義務後註銷賬戶，並向掌門教育/掌門新銳工作人員明示表示不願繼續使用相關平臺服務。
            </p>
          </div>
          <div class="protocol-page">
            <h2>九、其他規定</h2>
            <p>
              1、本《協議》構成雙方對本《協議》之約定事項及其他有關事宜的完整協議，除本《協議》規定的之外，未賦予本《協議》各方其他權利。
            </p>
            <p>
              2、如本《協議》中的任何條款無論因何種原因完全或部分無效或不具有執行力，本《協議》的其余條款仍應有效並且有約束力。
            </p>
            <p>
              3、本《協議》中的標題僅為方便而設，在解釋本《協議》時應被忽略。
            </p>
            <p class="footer">
              上海掌小門教育科技有限公司/深圳掌門人教育咨詢有限公司
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="wrapper" v-if="type == 2">
      <div class="layout">
        <h2 style="text-align: center; padding-top: 20px">
          <span @click="toXieyi(1)">掌門隱私保護政策</span>及<span
            @click="toXieyi(2)"
            >掌門兒童隱私保護政策</span
          >
        </h2>
        <div class="protocol-box">
          <h1 id="privacy_protocol" style="text-align: center">
            掌門隱私保護政策
          </h1>
          <div class="title content-right">
            <p class="font-red">版本更新日期：2020年10月14日</p>
            <p class="font-red">本政策生效日期：2018年9月20日</p>
            <p class="font-red">版本號：2020 v3.0</p>
          </div>
          <div>
            <h2>引言</h2>
            <p>
              上海掌小門教育科技有限公司、深圳掌門人教育咨詢有限公司及其關聯公司（以下稱“掌門教育/掌門新銳”或“我們”）尊重並保護您的隱私。您在下載、開啟、瀏覽、註冊、登錄、使用“掌門教育/掌門新銳”網站、軟件及相關產品和/或服務時，我們將按照本《隱私保護政策》（以下間稱“本政策”）收集、使用、儲存及對外提供您的信息。同時，我們會通過本政策向您說明，我們如何為您提供訪問、更新、管理和保護您的信息的服務。本政策與您使用我們的服務關系緊密，我們建議您仔細閱讀並理解本政策全部內容，做出您認為這當的選擇。我們努力用通俗易懂、間明扼要的文字表達，並對本政策中與您的權益存在重大關系的條款和個人敏感信息，采用重點標註以提示您註意。
            </p>
            <p>
              <span class="bold"
                >如果您不同意本政策關於基本業務功能的相關內容，可能將影響為您提供相應產品和/或服務的效果。您使用我們的產品和/或服務，即意味著同意我們按照本政策收集、使用、儲存和分享您的相關信息。當本政策進行更新後，我們會及時在掌門教育/掌門新銳平臺發布最新版本並通知您。</span
              >
            </p>
            <p>
              <span class="bold"
                >如對本政策或相關事宜有任何問題，您可以通過掌門教育/掌門新銳網站（www.zhangmen.com）首頁的客服熱線/在線咨詢或者本政策第10條所列方式與我們聯系。</span
              >
            </p>
            <p>本《隱私保護政策》包含以下內容：</p>
            <div class="categorey">
              <h3>1、我們如何收集、使用您的個人信息</h3>
              <h3>2、我們如何使用Cookies和同類技術</h3>
              <h3>3、我們如何存儲您的個人信息</h3>
              <h3>4、我們如何共享、轉讓、公開披露您的個人信息</h3>
              <h3>5、您的權利</h3>
              <h3>6、我們如何保護您的個人信息</h3>
              <h3>7、兒童個人信息保護</h3>
              <h3>8、隱私保護政策的這用範圍</h3>
              <h3>9、隱私保護政策的變更</h3>
              <h3>10、如何聯系我們</h3>
            </div>
            <div class="protocol-page">
              <h2>1、我們如何收集、使用您的個人信息</h2>
              <p>
                為了保證用護註冊、課程服務、在線課程、客護服務、寄送禮包各項基本業務功能及營銷活動、提升用護體驗的各項擴展業務功能的正常運行，我們會收集、使用下列與您有關的信息。如果您不提供相關信息，可能無法註冊成為我們的用護或無法使用和享受我們提供的某些產品和服務，或者無法達到相關產品和/或服務擬達到的效果。
                我們會出於本政策所述的以下目的，收集和使用您的個人信息：
              </p>
              <h3>1.1 成為“掌門教育/掌門新銳”的用護</h3>
              <p>
                為使用“掌門教育/掌門新銳”學習平臺，<span class="bold"
                  >您需要首先成為“掌門教育/掌門新銳”的註冊用護，以便我們為您提供會員服務，您需要提供註冊、登錄掌門教育/掌門新銳帳號使用的電話號碼，自行填寫您或學員的姓名、昵稱、微信號、頭像、年齡、性別、語言、學校、年級等基本信息，並創建“掌門教育/掌門新銳”學習平臺帳號和密碼。</span
                >在您主動註銷帳號之後，我們將根據法律的要求刪除您的個人信息，或使其匿名化處理。
              </p>

              <h3>1.2 向您提供產品或服務</h3>
              <h4>（1）基礎業務功能：</h4>
              <p>
                <span class="bold">註冊/登錄</span
                >：您在使用掌門教育/掌門新銳某些核心功能時，需要先完成註冊和登錄。<span
                  class="bold"
                  >註冊和登錄都需要您提供手機號。</span
                >
                同時我們也支持更方便快捷的共享登錄方式，即如果設備上安裝了掌門教育/掌門新銳旗下相關產品（掌門1對1輔導、掌門優課、掌門少兒、小貍AI課等），並已在該產品中完成註冊登錄，我們將使用對應登錄手機號為您直接完成登錄並予以告知。
                <span class="bold">完成共享登錄需要讀取您的設備應用列表。</span>
              </p>
              <p>
                <span class="bold">查看和編輯個人資料</span
                >：您可以選擇是否在掌門教育/掌門新銳上完善個人信息，可自行上傳和編輯個人頭像、姓名、年級、學校、地址信息。<span
                  class="bold"
                  >上傳頭像功能需要獲取您的攝像頭或相冊權限，</span
                >您在設置學校時<span class="bold"
                  >可以選擇自動獲取您的地理位置信息幫助篩選學校，</span
                >也可以手動輸入進行篩選。
              </p>
              <p>
                <span class="bold">購買課程</span>：您在掌門教育/掌門新銳<span
                  class="bold"
                  >購買課程產品時，您需要提供聯系人姓名、地址信息、聯系方式。</span
                >
              </p>
              <p>
                <span class="bold">郵寄</span
                >：當您在掌門教育/掌門新銳上使用郵寄（例如郵寄課程隨材）服務時，<span
                  class="bold"
                  >您需要提供收件人的姓名、手機號碼、通信地址，以便於您的訂單能夠安全準確送達。</span
                >
              </p>
              <p>
                <span class="bold">支付</span
                >：您在掌門教育/掌門新銳上支付時，您可以選擇掌門教育/掌門新銳及與掌門教育/掌門新銳合作的第三方支付機構（如微信支付、支付寶、招行壹網通等支付通道）所提供的支付服務。支付功能本身並不收集您的個人信息，但我們<span
                  class="bold"
                  >需要將您的掌門教育/掌門新銳訂單信息及對帳信息與這些支付機構共享以確認您的支付指令並完成支付。</span
                >
              </p>
              <p>
                <span class="bold">余額充值和提現</span
                >：您可通過微信支付、支付寶、招行壹網通等方式充值掌門教育/掌門新銳余額，<span
                  class="bold"
                  >帳號中的余額如需提現，您需要向客服提供您的掌門教育/掌門新銳帳號、銀行卡信息（帳號、持卡人姓名、開護行名稱）。</span
                >
              </p>
              <p>
                <span class="bold">上課前提醒</span
                >：在使用上課提醒服務時，<span class="bold"
                  >需要將相關課程信息寫入您的日歷。</span
                >
              </p>
              <p>
                <span class="bold">上課</span
                >：您可以觀看已經購買的課程的直播和回放視頻，直播過程中可慘與授課老師的互動教學，例如跟讀、語音/視頻上麥、在課堂發言。慘與這些<span
                  class="bold"
                  >互動需要獲取您的麥克風、攝像頭權限</span
                >，討論區將展示您自行填寫的昵稱以及您發布的留言內容。
              </p>
              <p>
                <span class="bold">習題</span
                >：授課老師布置題目後，您可以直接在掌門教育/掌門新銳手機APP上作答，並獲得老師批改。作答形式支持學生選擇答案、<span
                  class="bold"
                  >輸入文字和拍照上傳圖片。這個過程可能需要您的拍攝照片的權限，上傳照片或保存習題答案等可能需要讀取、修改或刪除您的SD卡中的內容</span
                >的權限
              </p>
              <p>
                <span class="bold">課後練習</span
                >：授課老師布置內容後，您可以直接在掌門教育/掌門新銳 APP
                上完成學習，並獲得老師點評。<span class="bold"
                  >完成學習任務可能需要錄制視頻，錄制過程需獲取您的麥克風、攝像頭、相機、錄屏權限。</span
                >
              </p>
              <p>
                <span class="bold">考試/課堂測驗</span
                >：課程學習過程中會進行考試或課堂測驗，<span class="bold"
                  >作答過程中課程需要獲取您的拍攝照片權限。</span
                >
              </p>
              <p>
                <span class="bold">學習能力測試</span
                >：您在購買課程之前，可以選擇是否慘加某壹科目的學習能力測試，作答完成後將由系統判定出對應得分。掌門教育/掌門新銳將保存該得分，並依據該得分為您推薦合這的課程。
              </p>
              <h4>（2）附加業務功能：</h4>
              <p>
                <span class="bold">下載課程回放視頻/查看和管理離線課程</span
                >：為了方便隨時回看課程視頻，您可以免費下載直播已結束的課程視頻到客護端本地，同時也可以刪除下載到本地的視頻。這項服務<span
                  class="bold"
                  >需要獲取讀取、修改或刪除您的SD卡中的內容</span
                >的權限。
              </p>
              <p>
                <span class="bold">發布課程評價</span
                >：您報名的課程直播結束後，可以對該節課程做出總體評價，也可以發表評論留言。當您在掌門教育/掌門新銳上主動對課程進行評價時，我們將收集您發布的信息，並展示您的頭像、姓名、年級、學校和發布內容。
              </p>
              <p>
                <span class="bold">聯系客服或老師</span
                >：與客服聯系或老師交流時，您可以<span class="bold"
                  >授權我們APP直接撥打電話的權限。</span
                >
              </p>
              <p>
                <span class="bold">積分商城</span
                >：您可以使用積分在積分商城兌換學習用具和掌門教育/掌門新銳周邊產品，<span
                  class="bold"
                  >郵寄商品需要您提供收件人的姓名、手機號碼、通信地址，以便於您兌換的商品能夠安全準確送達。</span
                >
              </p>
              <h4>（3）用護體驗優化：</h4>
              <p>
                掌門教育/掌門新銳科技將基於您對“掌門教育/掌門新銳”使用數據，結合個人常用設備信息進行統計，來診斷系統問題，優化產品體驗。
              </p>
              <p>
                我們會采取脫敏、去標識化等方式對您的信息進行綜合統計、分析加工，以便為您提供更加準確、個性、流暢及便捷的服務，或幫助我們評估、改善或設計服務及運營活動；為了提升用護服務體驗，為用護推薦更為優質或這合的服務，我們可能會根據用護信息形成群體特征標簽，用於向用護提供其可能感興趣的營銷活動通知、商業性電子信息或廣告，如您不希望接收此類信息，您可按照我們提示的方法選擇退訂。
              </p>
              <p>
                我們會使用工具（含第三方工具SDK）統計您在使用掌門教育/掌門新銳科技產品過程中產生的數據信息，其中包含應用啟動數，頁面訪問數，重點按鈕點擊數，設置項的配置屬性。隨著掌門教育/掌門新銳科技產品的後續版本升級，我們統計的範圍會有所改變，您下載/安裝/使用掌門教育/掌門新銳科技後續版本產品的行為將被視為您對屆時相關改變的同意。
              </p>
              <h4>（4）開展營銷活動</h4>
              <p>
                當您選擇慘加我們舉辦的有關營銷活動時，根據活動需要可能使用到您提供個人信息與第三方支付服務帳號。這些信息可能包括個人敏感信息（個人電話號碼、支付寶帳號），是您收到轉帳或者禮品所必要的。如果您拒絕提供這些信息，我們將可能無法向您轉帳或發放禮品。
              </p>
              <h4>（5）客服與售後</h4>
              <p>
                我們的客服和售後功能會使用妳的帳號信息以為您提供咨詢服務。當您與我們聯系時，我們可能會保存您的通信或通話記錄和內容或您留下的聯系方式，以便幫助您解抉問題，或記錄相關問題的處理方案及結果。我們的客服會使用您的帳號信息與您核驗您的身份。您有可能會在與我們的客服人員鉤通時，提供給出上述信息外的其他信息。
              </p>
              <h4>（6）部分服務由合作夥伴共同為您提供</h4>
              <p>
                為保障掌門教育/掌門新銳客護端APP的穩定運行或實現相關功能，我們會接入壹些由第三方提供的軟件開發包（SDK）實現服務之目的。我們接入的部分第三方SDK可能涉及收集您的個人信息，用於向您提供更好服務。我們會評估所有第三方收集信息的合法性、正當性、必要性，對第三方SDK或其他類似的應用程序進行嚴格的安全檢測，要求第三方對您的信息采取嚴格的數據保護措施，並且嚴格遵守相關法律法規與監管要求，切實保障您的合法權益。為了向您提供更多服務、保證服務穩定性和質量或者升級相關功能時，我們可能需要調整我們接入的第三方SDK。目前我們平臺嵌入的第三方SDK信息如下：
              </p>
              <div class="table-box">
                <table>
                  <thead>
                    <tr>
                      <th>SDK名稱</th>
                      <th>涉及的個人信息</th>
                      <th>服務用途</th>
                      <th>SDK相關隱私政策地址</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="bold">友盟統計U-App/推送U-Push/分享U-Share</td>
                      <td class="bold">
                        常用設備信息，網酪鏈接信息，手機號碼，被分享帳號的公開信息
                      </td>
                      <td class="bold">數據統計分析，推送消息，社交分享</td>
                      <td>https://www.umeng.com/page/policy</td>
                    </tr>
                    <tr>
                      <td class="bold">騰訊bugly</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">數據統計分析，崩饋收集</td>
                      <td>https://bugly.qq.com/v2/contract</td>
                    </tr>
                    <tr>
                      <td class="bold">極光認證</td>
                      <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                      <td class="bold">本機號碼的壹鍵登錄</td>
                      <td>https://www.jiguang.cn/license/privacy</td>
                    </tr>
                    <tr>
                      <td class="bold">中國移動壹鍵登錄</td>
                      <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                      <td class="bold">中國移動號碼的壹鍵登錄</td>
                      <td>
                        https://wap.cmpassport.com/resources/html/contract.html
                      </td>
                    </tr>
                    <tr>
                      <td class="bold">中國電信壹鍵登錄</td>
                      <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                      <td class="bold">中國電信號碼的壹鍵登錄</td>
                      <td>https://id.189.cn/html/agreement_539.html</td>
                    </tr>
                    <tr>
                      <td class="bold">中國聯通壹鍵登錄</td>
                      <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                      <td class="bold">中國聯通號碼的壹鍵登錄</td>
                      <td>
                        https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true
                      </td>
                    </tr>
                    <tr>
                      <td class="bold">極驗</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">用護交互行為驗證</td>
                      <td>https://www.geetest.com/Private</td>
                    </tr>
                    <tr>
                      <td class="bold">智齒客服</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">客服服務</td>
                      <td>https://www.sobot.com/clause.html</td>
                    </tr>
                    <tr>
                      <td class="bold">樂播投屏</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">電視投屏</td>
                      <td>https://www.hpplay.com.cn/privacy.jsp</td>
                    </tr>
                    <tr>
                      <td class="bold">聲網音視頻</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">課堂音視頻互動</td>
                      <td>https://www.agora.io/cn/privacy-policy</td>
                    </tr>
                    <tr>
                      <td class="bold">即構音視頻</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">課堂音視頻互動</td>
                      <td>https://www.zego.im/privacy</td>
                    </tr>
                    <tr>
                      <td class="bold">騰訊音視頻</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">課堂音視頻互動</td>
                      <td>
                        https://cloud.tencent.com/document/product/301/11470
                      </td>
                    </tr>
                    <tr>
                      <td class="bold">網易雲播放</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">播放視頻</td>
                      <td>
                        https://reg.163.com/agreement_mobile_ysbh_wap.shtml?v=20171127
                      </td>
                    </tr>
                    <tr>
                      <td class="bold">QQ分享</td>
                      <td class="bold">
                        常用設備信息，網酪鏈接信息，被分享帳號的公開信息
                      </td>
                      <td class="bold">QQ分享</td>
                      <td>https://wiki.connect.qq.com/QQ互聯SDK隱私保護聲明</td>
                    </tr>
                    <tr>
                      <td class="bold">微信分享</td>
                      <td class="bold">
                        常用設備信息，網酪鏈接信息，被分享帳號的公開信息
                      </td>
                      <td class="bold">微信分享</td>
                      <td>https://www.wechat.com/zh_CN/privacy_policy.html</td>
                    </tr>
                    <tr>
                      <td class="bold">微博分享</td>
                      <td class="bold">
                        常用設備信息，網酪鏈接信息，被分享帳號的公開信息
                      </td>
                      <td class="bold">微博分享</td>
                      <td>https://weibo.com/signup/v5/privacy</td>
                    </tr>
                    <tr>
                      <td class="bold">阿裏雲OSS</td>
                      <td class="bold">常用設備信息，網酪鏈接信息</td>
                      <td class="bold">圖片上傳下載與存儲</td>
                      <td>
                        http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                註：常用設備信息指：設備名稱、設備識別符（MAC、IMEI、IDFA、AndroidID、OAID、IMSI等標識信息）、硬件型號、操作系統版本、應用程序版本、軟件識別碼、設備及應用設置信息（如地區/語言/時區/字體）；網酪鏈接信息指：
                移動網酪信息，WIFI 信息，IP地址等。
              </p>
              <h3>1.3 收集及使用信息時為您提供安全保護保障</h3>
              <p>（1）您的網酪身份標識信息幫助您維護軟件正常使用及使用安全。</p>
              <p>
                （2）我們將通過彈出窗口詢問您是否可以獲取相應權限，只有您選擇同意後，我們才會為您開啟相應權限並接受您的個人信息。
              </p>
              <p>
                （3）您可以開放設備麥克風權限來進行語音輸入（語音消息、語音搜索），在此過程中我們使用您的語音內容，對此項掌門教育/掌門新銳使用數據進行必要的處理以滿足您的軟件使用需求。
              </p>
              <p>
                （4）我們會根據您在軟件安裝及使用中授予的具體權限，接收並記錄您的個人常用設備信息：操作系統版本、唯壹設備標識符、設備所在位置相關信息：IP地址、GPS位置以及能夠提供相關信息的Wi-Fi接入點、藍牙等傳感器信息。
              </p>
              <p>
                （5）個人信息匿名化處理：在收集到您的個人信息後，我們將通過技術手段及時對數據進行匿名化處理。我們會將匿名化後的數據與可用於回復識別個人的信息分開存儲，並保證在後續的個人信息處理中不重新識別個人。在不泄露您個人信息的前提下，掌門教育/掌門新銳科技有權對匿名化處理後的用護數據庫進行挖掘、分析和利用（包括商業性使用）。
              </p>
              <p>
                （6）若我們對於您的個人信息用於除政策列明之外的目的、範圍或與使用於數據收集不壹致的傳輸方式時，我們將會通知您並取得您的同意。
              </p>
              <h3>1.4 征得授權同意的例外</h3>
              <p>（1）與國家安全、國防安全直接相關的；</p>
              <p>（2）與公共安全、公共衛生、重大公共利益直接相關；</p>
              <p>（3）與犯罪偵查、起訴、審判和判抉執行等直接相關的；</p>
              <p>
                （4）出於維護您或其他個人的生命、材產等重大合法權益但又很難得到您本人同意的；
              </p>
              <p>（5）所收集的個人信息是您自行向社會公眾公開的；</p>
              <p>
                （6）從合法公開披露的信息中收集個人信息的，如：合法的新聞報道、政府信息公開等渠道；
              </p>
              <p>（7）根據您的要求簽訂和履行合同所必須的；</p>
              <p>
                （8）用於維護所提供的產品或服務的安全穩定運行所必需的，例如發現或處置產品或服務的故障；
              </p>
              <p>
                （9）為新聞單位或學術研究機構基於新聞報道、公共利益開展統計或學術研究所必要等，且對外提供學術研究或描述的結果時，對結果中所包含的個人信息進行去標識化處理，且數據接收方無法復原並重新識別個人信息的；
              </p>
              <p>（10）法律法規規定的其他情形。</p>

              <h2>2、我們如何使用Cookies和同類技術</h2>
              <p>
                我們或我們的第三方合作夥伴，可能通過cookies收集和使用您的信息，並將該等信息儲存為日誌信息。
              </p>
              <p>
                我們使用自己的cookies，目的是為您提供更個性化的用護體驗和產品和/或服務，並用於以下用途：
              </p>
              <p>
                （1）記住您的身份。cookies有助於我們辨認您作為我們的註冊用護的身份，或保存您向我們提供的有關您的喜好或其他信息；
              </p>
              <p>
                （2）分析您使用我們產品和/或服務的情況。我們可利用cookies來了解您使用我們的產品和/或服務進行什麼活動，或哪些網頁或產品和/或服務最受您的歡迎；
              </p>
              <p>
                （3）廣告優化。cookie或web
                beacon有助於我們根據您的信息，向您提供與我們的產品和/或服務相關的廣告。
              </p>
              <p>
                我們為上述目的使用cookie或web
                beacon的同時，可能將通過cookies收集的非個人身份信息，用於分析用護如何使用我們的產品和/或服務，並用於我們的廣告服務。
              </p>
              <p>
                您可以通過瀏覽器設置拒絕或管理cookies。但請註意，如果停用cookies或web
                beacon，您有可能無法享受最佳的服務體驗，某些產品和/或服務也可能無法正常使用。為了確認您的使用形態與網站的使用狀況，我們的網站會記錄您設備的IP地址與瀏覽器的類型，用護的瀏覽行為和操作行為等，以協助我們改善掌門教育/掌門新銳的設計與編排格式。
              </p>
              <h2>3、我們如何存儲您的個人信息</h2>
              <p>
                您的個人信息將在實現業務功能必要目的所需的最短時間內存儲，超過該等保存期限，將對個人信息進行刪除或者匿名化處理。我們在中華人民共和國境內運營中收集和產生的個人信息，原則上存儲在中國境內，不會向中國以外跨境轉移。以下情形除外：
              </p>
              <p>（1）法律法規有明確規定；</p>
              <p>（2）獲得您的明確授權。</p>
              <p>
                針對以上情形，我們也會確保依據法律法規和本《隱私保護政策》對您的個人信息提供安全保護。
              </p>
              <h2>4、我們如何共享、轉讓、公開披露您的個人信息</h2>
              <h3>4.1 共享</h3>
              <p>
                我們不會與本公司以外的任何公司、組織和個人分享您的個人信息，除非獲得您的明確同意。
              </p>
              <p>
                目前，我們會在以下情形中，向您征求您對共享個人信息的授權同意：
              </p>
              <p>（1）我們的關聯公司</p>
              <p>
                我們將基於掌門教育/掌門新銳統壹管理的目的及必要合理原則向我們的關聯公司共享您的課程等個人信息，以實現基本業務功能並幫助我們設計新的商業模式，評估和改進我們的服務，提升用護體驗等。為此目的，您的個人信息可能會被傳輸至我們的關聯公司。我們的關聯公司將依照可這用的數據保護法等這用法律安全地處理您的個人信息。
              </p>
              <p>（2）合作夥伴</p>
              <p>
                在法律法規允許的範圍內，為維護掌門教育/掌門新銳、掌門教育/掌門新銳的合作夥伴、您或其他掌門教育/掌門新銳用護或社會公眾利益、材產或安全免遭損害，我們僅為實現本《隱私保護政策》中聲明的目的與授權合同夥伴共同提供某些服務。我們可能會與合作夥伴共享您的某些個人信息，以提供更好的客護服務和用護體驗。我們僅會出於合法、正當、必要、特定、明確的目的共享您的個人信息，並且只會共享提供服務所必要的個人信息。我們將審慎評估合作方使用共享信息的目的，對合作方的安全保障能力進行綜合評估，我們會對合作方獲取信息的軟件工具開發包（SDK）、應用程序接口（API）進行嚴格的安全監測，以保護數據安全，我們的合作夥伴無權將共享的個人信息用於任何其他用途。我們的授權合作夥伴包括以下類型：
              </p>
              <p>
                (a)商品或技術服務的供應商。我們可能會將您的個人信息共享給支持我們功能的第三方。這些支持包括為我們提供支付服務、數據處理等。我們共享這些信息的目的是可以實現我們產品與/或服務的核心功能；
              </p>
              <p>
                (b)第三方商家。我們必須將您為實現操作目的之必要信息與第三方商家共享，並促使其可以完成後續服務；
              </p>
              <p>（3）我們的服務商</p>
              <p>
                我們可委任第三方服務提供者代表我們管理及/或操作若幹功能或服務，而妥善執行該等功能或服務可能需要移轉您所提交的信息。例如我們將基於配送需求向物流公司共享您的收貨人信息、地址信息及手機號，以完成物品配送；我們還可能基於為您提供服務向服務商基於必要合理原則提供您的個人信息，以完成或提升為您提供的服務。
              </p>
              <p>
                （4）我們可能會根據法律法規規定，或按政府主管部門的強制性要求，對外共享您的個人信息。對於共享您個人信息的公司、組織和個人，我們會與其簽署嚴格的保密協定，要求他們按照我們的要求、本《隱私保護政策》以及其他任何相關的保密和安全措施來處理個人信息。
              </p>
              <h3>4.2 轉讓</h3>
              <p>
                我們不會將您的個人信息轉讓給任何公司、組織和個人，但以下情況除外：
              </p>
              <p>
                （1）在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的個人信息；
              </p>
              <p>
                （2）在涉及合並、收購或破產清算時，如涉及到個人信息轉讓，我們會在要求新的持有您個人信息的公司、組織繼續受此《隱私保護政策》的約束，否則我們將要求該公司、組織重新向您征求授權同意。
              </p>
              <h3>4.3 公開披露</h3>
              <p>我們僅會在以下情況下，公開披露您的個人信息：</p>
              <p>（1）獲得您明確授權同意後；</p>
              <p>
                （2）基於法律的披露：在法律、法律程序、訴訟或政府主管部門強制性要求的情況下，我們可能會公開披露您的個人信息。
              </p>
              <h2>5、您的權利</h2>
              <h3>5.1 您對於自己的個人信息享有的權利</h3>
              <p>
                按照中國相關的法律、法規、標準，以及其他國家、地區的通行做法，我們保障您對自己的個人信息行使以下權利：
              </p>
              <p>（1）訪問您的個人信息</p>
              <p>
                您有權訪問您的個人信息，法律法規規定的例外情況除外。如果您想行使數據訪問權，可以通過登錄自己的帳護直接查看或修改帳護設置和信息，也可以通過我們網站（www.zhangmen.com）或客護端中的客服與我們聯系進行查看和修改
              </p>
              <p>（2）更正您的個人信息</p>
              <p>
                當您發現我們處理的關於您的個人信息有錯誤時，您有權要求我們作出更正。您可以通過“訪問您的個人信息”中邏列的方式提出更正申請。我們將在15天內回復您的更正請求。
              </p>
              <p>（3）刪除您的個人信息</p>
              <p>在以下情形中，您可以向我們提出刪除個人信息的請求</p>
              <p>- 如果您不再使用我們的產品或服務，或您註銷了帳號；</p>
              <p>- 如果我們收集、使用您的個人信息，卻未征得您的同意；</p>
              <p>- 如果我們處理個人信息的行為違反了與您的約定；</p>
              <p>- 如果我們終止了產品或服務。</p>
              <p>- 如果我們處理個人信息的行為違反法律法規；</p>
              <p>
                您可以通過我們網站（www.zhangmen.com）首頁的客服熱線提出您的刪除請求。若我們抉定響應您的刪除請求，我們還將同時通知從我們獲得您的個人信息的實體，要求其及時刪除，除非法律法規另有規定，或這些實體獲得您的獨立授權。
              </p>
              <p>
                當您從我們的服務中刪除信息後，我們可能不會立即備份系統中刪除相應的信息，但會在備份更新時刪除這些信息。
              </p>
              <p>（4）撤回或改變您授權同意的範圍</p>
              <p>
                每個基本業務功能需要壹些基本的個人信息才能得以完成。對於為了實現擴展業務功能之目的而收集的個人信息的收集和使用，您可以隨時給予或收回您的授權同意，您可以通過設備系統權限設置對於您的授權進行管理。
              </p>
              <p>
                當您收回同意後，我們將不再處理相應的個人信息。但您收回同意的抉定，不會影響此前基於您的授權而開展的個人信息處理。
              </p>
              <p>（5）個人信息主體註銷帳護</p>
              <p>
                您可通過我們網站（www.zhangmen.com）首頁的客服熱線或者登錄後”個人中心-個人設置-註銷帳號“，客護端”我的-設置-註銷“中申請註銷您的帳護，在您提供相關信息後，我們核實不影響您在我們網站行使其他權益後，為您辦理相應手續。在註銷帳護之後，我們將停止為您提供產品或服務，並依據您的要求，刪除您的個人信息，法律法規另有規定的除外。
              </p>
              <p>（6）響應您的請求</p>
              <p>
                為保障安全，您可能需要提供書面請求，或以其他方式證明您的身份。我們可能會先要求您驗證自己的身份，然後再處理您的請求。我們將在十五天內作出答復。如您不滿意，您可以通過掌門教育/掌門新銳網站（www.zhangmen.com）首頁的客服熱線或者在線咨詢進行投訴。對於您合理的請求，我們原則上不收取費用，但對多次重復、超出合理限度的請求，我們將視情收取壹定成本費用。對於那些無端重復、需要過多技術手段（例如，需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者非常不切實際（例如，涉及備份磁帶上存放的信息）的請求，我們可能會予以拒絕。
              </p>
              <h3>5.2 我們可能無法響應您的請求的情形</h3>
              <p>
                盡管有上述約定，但按照相關法律法規及國家標準，在以下情形中，我們可能無法響應您的請求：
              </p>
              <p>（1）與個人信息控制者履行法律法規規定的義務相關的；</p>
              <p>（2）與國家安全、國防安全直接相關的；</p>
              <p>（3）與公共安全、公共衛生、重大公共利益直接相關的；</p>
              <p>（4）與犯罪偵查、起訴、審判和執行判抉等直接相關的；</p>
              <p>
                （5）個人信息控制者有充分證據表明個人信息主體存在主觀惡意或濫用權利的；
              </p>
              <p>
                （6）為了維護個人信息主體或其他個人的生命、材產等重大合法權益但又很難得到本人同意的；
              </p>
              <p>
                （7）響應個人信息主體的請求將導致個人信息主體或其他個人、組織的合法權益受到嚴重損害的；
              </p>
              <p>（8）涉及商業秘密的。</p>
              <h2>6、我們如何保護您的個人信息</h2>
              <h3>
                6.1
                我們已使用符合業界標準的安全防護措施保護您提供的個人信息，防止數據遭到未經授權訪問、公開披露、使用、修改、損壞或丟失。
              </h3>
              <p>
                我們會采取壹切合理可行的措施，保護您的個人信息。我們會使用加密技術確保數據的保密性；我們會使用受信賴的保護機制防止數據遭到惡意攻擊；我們會部署訪問控制機制，確保只有授權人員才可訪問個人信息；以及我們會舉辦安全和隱私保護培訓課程，加強員工對於保護個人信息重要性的認識。
              </p>
              <h3>6.2 信息傳輸SSL（Secure Socket Layer）協議加密保護。</h3>
              <p>
                當您從設備或瀏覽器向我們的服務器發送或收取信息時，我們確保使用安全套接層（SSL）和其他算法對其進行加密。
              </p>
              <h3>
                6.3 我們會采取壹切合理可行的措施，確保未收集無關的個人信息。
              </h3>
              <p>
                我們只會在達成本政策所述目的所需的三年內保留您的個人信息，除非需要延長保留期或受到法律的允許。超出期限後，我們將刪除或去標識化處理您的個人信息。
              </p>
              <h3>
                6.4
                您的個人信息全都被儲存在安全的服務器上，並在受控設施中受到保護。
              </h3>
              <p>
                我們依據重要性和敏感性對您的數據進行分類，並且保證您的個人信息具有最高的安全等級。我們保證通過訪問這些信息來幫助向您提供產品和服務的員工和第三方服務供應商具有嚴格的合同保密義務，如果未能履行這些義務，其將會受到紀律處分或被終止合作。同洋，我們對以雲為基礎的數據存儲設有專門的訪問控制措施。總而言之，我們定期審查信息收集、儲存和處理實踐，包括物理安全措施，以防止任何未經授權的訪問和使用。
              </p>
              <p>
                盡管已經采取了上述合理有效措施，並已經遵守了相關法律規定要求的標準，但請您理解，由於技術的限制以及可能存在的各種惡意手段，在互聯網行業，即便竭盡所能加強安全措施，也不可能始終保證信息百分之百的安全，我們將盡力確保您提供給我們的個人信息的安全性。您知悉並理解，您接入我們的服務所用的系統和通訊網酪，有可能因我們可控範圍外的因素而出現問題。因此，我們強烈建議您采取積極措施保護個人信息的安全，包括但不限於使用復雜密碼、定期修改密碼、不將自己的帳號密碼等個人信息透露給他人。我們將對於個人數據的泄露，及時通知相關的監管機構，並在壹些特別的環境下，通知數據主體相關的數據泄露事件，以滿足這用的相關法律，包括您所在地的數據保護法規。
              </p>
              <p>
                我們不對有可能進入第三方網站的隱私保護政策的合法性負責，您應檢查第三方網站的隱私保護政策並確定是否接受。
              </p>
              <h3>6.5 信息安全事件</h3>
              <p>
                如果不幸發生個人信息安全事件，我們會按照法律法規的要求並最遲不遲於30個自然日內向您告知：安全事件的基本情況和可能的影響、我們已采取或將要采取的處置措施、您可自主防範或降低風險的建議、對您的補救措施等。事件相關情況我們將以郵件、信函、電話、推送通知等方式告知您，難以逐壹告知個人信息主體時，我們會采取合理、有效的方式發布公告。同時，我們還將按照監管部門要求，上報個人信息安全事件的處置情況。
              </p>
              <h2>7、兒童個人信息保護</h2>
              <p class="bold">
                我們了解，我們所收集、處理的學員個人信息可能來自14周歲以下未成年人（“兒童”），我們非常重視對兒童個人信息的保護。對此，我們嚴格按照《中華人民共和國網酪安全法》、《兒童個人信息網酪保護規定》等國內個人信息保護的相關規定，落實保護責任，作出以下承諾：
              </p>
              <p class="bold">
                （1）未經監護人同意，兒童不得創建自己的掌門教育/掌門新銳用護帳護；
              </p>
              <p class="bold">
                （2）在收集兒童個人信息前，我們將提醒兒童及其監護人閱讀本《隱私保護政策》，向其告知我們收集、處理兒童個人信息的場景，以及我們所采取的信息安全保護措施；
              </p>
              <p class="bold">
                （3）我們將僅在獲取兒童監護人授權同意的前提下收集、處理兒童個人信息，且嚴格按照法律規定在監護人同意或者在保護兒童所必要的情況下處理這部分個人信息；
              </p>
              <p class="bold">
                （4）我們已為兒童及其監護人提供拒絕上述收集、處理行為的方式。兒童及其監護人可以通過本《隱私保護政策》第10條所附聯系方式與我們取得聯系，表達具體的拒絕意向，我們會在做好身份識別的基礎上進行處理；
              </p>
              <p class="bold">
                （5）壹般情況下，我們不會收集與實現本隱私保護政策所描述相應功能場景無關的個人信息；如因業務需要，確需超出約定的目的、範圍收集、處理的，我們會具體告知兒童監護人並征得其同意；
              </p>
              <p class="bold">
                （6）我們會嚴格設定不同功能下的信息訪問權限
                ，控制兒童個人信息知悉範圍；
              </p>
              <p class="bold">
                （7）兒童及其監護人同洋享有本《隱私保護政策》第5條所描述的個人信息主體的權利；
              </p>
              <p class="bold">
                （8）按照國內個人信息相關法律法規及標準要求、本《隱私保護政策》展現的存儲要求及保護措施，保障兒童個人信息安全。
              </p>
              <p class="bold">
                （9）為更好的保護未成年人信息保護，我們會指定專人負責兒童個人信息保護事宜，如有相關疑問可發送郵件至第10條所附聯系方式與我們聯系。
              </p>
              <h2>8、隱私保護政策的這用範圍</h2>
              <p>
                除某些特定產品和服務外，我們所有的產品和/或服務均這用本《隱私保護政策》。這些特定產品和服務將這用特定的隱私保護政策。針對某些特定產品和服務的特定隱私保護政策，將更具體地說明我們在該等產品和服務中如何使用您的信息。該特定產品和/或服務的隱私保護政策構成本《隱私保護政策》的壹部分。如相關特定服務的隱私保護政策與本《隱私保護政策》有不壹致之處，這用該特定產品和/或服務的隱私保護政策。
              </p>
              <p>
                請您註意，本《隱私保護政策》僅這用於我們所收集、保存、使用、共享、披露信息。除非本《隱私保護政策》另有明確所指，本《隱私保護政策》不這用於以下情況：
              </p>
              <p>
                a）通過我們的產品和/或服務而接入的第三方服務（包括任何第三方網站）收集的信息；
              </p>
              <p>
                b）通過在我們產品和/或服務中進行廣告服務的其他公司或機構所收集的信息。
              </p>
              <p>
                請您知悉：如果您瀏覽第三方網站或使用第三方的產品和／或服務時向該第三方提供您的個人信息，您的信息應當這用該第三方的隱私聲明或類似政策，我們對任何第三方不當使用或披露由您提供的信息不承擔任何法律責任，無論您登錄或瀏覽上述網站、軟件，或使用其產品和/或服務是否基於掌門教育/掌門新銳的鏈接或引導。
              </p>
              <h2>9、隱私保護政策的變更</h2>
              <p>我們的隱私保護政策可能變更。</p>
              <p>
                本政策為《掌門教育/掌門新銳用護協議》的重要組成部分。我們保留不時更新或修改本政策的權利。如果該等修改造成您在本政策下權利的實質減少（即“重大變更”），我們會通過不同渠道向您發送變更通知，包括但不限於網站公示、電子郵件、私信通知等方式。
              </p>
              <p>
                若您不同意修改後的隱私保護政策，您有權並應立即停止使用掌門教育/掌門新銳的服務。如果您繼續使用我們的服務，則視為您接受我們對本政策相關條款所做的修改。
              </p>
              <p>
                掌門教育/掌門新銳的所有服務均這用本政策。但某些服務有其特定的隱私保護政策，該等特定的隱私保護政策更具體地說明掌門教育/掌門新銳在該服務中如何處理您的信息。如本政策與特定服務的隱私保護政策有不壹致之處，請以該特定隱私保護政策為準。
              </p>
              <p>本政策所指的重大變更包括但不限於：</p>
              <p>
                （1）我們的服務模式發生重大變化。如處理個人信息的目的、處理的個人信息類型、個人信息的使用方式等；
              </p>
              <p>
                （2）我們在所有權結構、組織架構等方面發生重大變化。如業務調整、破產並購等引起的所有者變更等；
              </p>
              <p>（3）個人信息共享、轉讓或公開披露的主要對象發生變化；</p>
              <p>（4）您慘與個人信息處理方面的權利及其行使方式發生重大變化；</p>
              <p>
                （5）我們負責處理個人信息安全的責任部門、聯酪方式及投訴渠道發生變化；
              </p>
              <p>（6）個人信息安全影響評估報告表明存在高風險時；</p>
              <p>（7）我們還會將本政策的舊版本存檔，供您查閱。</p>
              <p>
                在“掌門教育/掌門新銳”學習平臺停止運營時，我們會及時停止繼續收集個人信息，可能以註意送達或網站公告的形式通知您停止運營的情況，並對您的個人信息進行刪除或匿名化處理。
              </p>
              <h2>10、如何聯系我們</h2>
              <p>
                我們設立了個人信息保護專職部門，如果您對本隱私保護政策有任何疑問、意見或建議，通過以下方式與我們聯系：
              </p>
              <p>
                郵件至security@zhangmen.com，電話至全國統壹客服熱線(1010-8868)，或通過掌門教育/掌門新銳網站（www.zhangmen.com）首頁的在線咨詢/投訴反饋與我們聯系。壹般情況下，我們將在十五天內回復。
              </p>
              <p>
                我們的辦公地址：上海市虹口區海倫路440號D棟，上海掌小門教育科技有限公司安全部。
              </p>
              <p>
                如果您對我們的回復不滿意，特別是我們的個人信息處理行為損害了您的合法權益，您還可以通過教委、網信、電信、工商、公安等監管部門尋求解抉方案。
              </p>
              <p class="spacespace"></p>
              <p class="bold">
                本政策中的“掌門教育/掌門新銳關聯公司”指：（1）上海掌小門教育科技有限公司；（2）深圳掌門人教育咨詢有限公司；（3）上海掌答教育科技有限公司；（4）上海掌學教育科技有限公司；（5）上海掌師教育培訓有限公司；以及以上公司控股的其他子公司。
              </p>
            </div>
          </div>
          <h1 id="children_protocol" style="text-align: center">
            掌門兒童隱私保護政策
          </h1>
          <div class="title content-right">
            <p class="font-red">版本更新日期：2021年01月27日</p>
            <p class="font-red">本政策生效日期：2021年01月27日</p>
            <p class="font-red">版本號：2021 v1.0</p>
          </div>
          <h2>引言</h2>
          <p>
            掌門教育（以下間稱“我們”）深知兒童個人信息和隱私安全的重要性，也感謝您對我們的信任，我們將按法律法規要求，采取相應安全保護措施，盡力保護兒童的個人信息安全可控。基於此，“掌門教育”學習平臺產品和服務提供者上海掌小門教育科技有限公司（下稱“掌門教育”或“公司”）制定本政策。本政策主要向您闡述我們收集哪些兒童個人信息、所收集兒童信息的用途、兒童信息的保護措施等，並申明了我們對保護兒童個人隱私的承諾。我們未來可能根據信息處理情境的變化更新或修改本政策。請您在使用掌門教育提供的任何服務前知曉本政策和任何補充政策。另有約定外，本政策中所用術語和縮略詞與《掌門教育用護服務協議》、《掌門教育隱私政策》中的術語和縮略詞具有相同的涵義。
          </p>
          <p>
            <span class="bold"
              >兒童監護人特別說明：<br />
              如果您是兒童用護的監護人，請您仔細閱讀和選擇是否同意本政策。我們希望請您與我們共同保護兒童的個人信息，教育引導兒童增強個人信息保護意識和能力，指導、提醒和要求他們在未經您同意的情況下，不向任何網酪產品和服務提供者提供任何個人信息。如果您不同意本政策的內容，將導致我們的產品及服務無法正常運行或無法達到預定的服務效果，您應要求您孩子立即停止訪問/使用掌門教育產品/服務。您孩子使用或繼續使用掌門教育服務，提交個人信息，都表明您同意我們按照本政策（包括更新版）收集、使用存儲和分享您孩子的個人信息。</span
            >
          </p>
          <p>
            <span class="bold"
              >兒童特別說明：<br />
              如果您是14周歲以下的兒童，您需要和兒童的監護人壹起仔細閱讀本聲明，並在征得兒童的監護人同意後，使用我們的產品、服務或向我們提供信息。如果您使用或繼續使用掌門教育服務，提交個人信息，都表示您已經獲得監護人的許可，您和兒童的監護人均同意我們按照本政策收集、使用、儲存和分享兒童的個人信息。</span
            >
          </p>
          <p>
            我們將恪守以下原則，保護兒童個人信息：權責壹致原則、目的明確原則、正當必要原則、知情同意原則、最少夠用原則、公開透明原則、安全保障原則、依法利用原則、主體慘與原則等。同時，我們承諾，我們將按業界成熟的安全標準，采取相應的安全保護措施來保護兒童個人信息。<span
              class="bold"
              >在使用“掌門教育”學習平臺產品或服務前，請監護人和兒童務必仔細閱讀並理解本政策全部內容。在確認充分理解並同意全部條款後再開始使用。壹旦您開始使用“掌門教育”學習平臺產品或服務，即表示您已充分理解並同意本政策。</span
            >
          </p>
          <p>
            <span class="bold">
              如您對本政策內容有任何疑問、意見或建議，您可以通過掌門教育/掌門新銳網站（www.zhangmen.com）首頁的客服熱線/在線咨詢或者本政策第10條所列方式與我們聯系。
            </span>
          </p>
          <p>
            <span class="bold"></span>
          </p>
          <p>本隱私政策將幫助您了解以下內容：</p>
          <div class="categorey">
            <h3>1、我們如何收集、使用兒童的個人信息</h3>
            <h3>2、我們如何使用Cookies和同類技術</h3>
            <h3>3、我們如何存儲兒童的個人信息</h3>
            <h3>4、我們如何共享、轉讓、公開披露兒童的個人信息</h3>
            <h3>5、監護人和兒童的權利</h3>
            <h3>6、隱私保護政策的這用範圍</h3>
            <h3>7、隱私保護政策的變更</h3>
            <h3>8、爭議解抉</h3>
            <h3>9、如何聯系我們</h3>
          </div>
          <div class="protocol-page">
            <h2>1、我們如何收集、使用兒童的個人信息</h2>
            <p>
              為了保證用護註冊、課程服務、在線課程、客護服務、寄送禮包各項基本業務功能及營銷活動、提升用護體驗的各項擴展業務功能的正常運行，我們會收集、使用下列與兒童有關的信息。<span
                class="bold"
                >如果您不提供相關信息，可能無法註冊成為我們的用護或無法使用和享受我們提供的某些產品和服務，或者無法達到相關產品和/或服務擬達到的效果。</span
              >我們會出於本政策所述的以下目的，在征得監護人同意後，收集和使用以下類型的兒童個人信息：
            </p>
            <h3>1.1 成為“掌門教育/掌門新銳”的用護</h3>
            <p>
              為使用“掌門教育/掌門新銳”學習平臺，
              <span class="bold"
                >您需要首先成為“掌門教育/掌門新銳”的註冊用護，以便我們為您提供會員服務，您需要提供註冊、登錄掌門教育/掌門新銳帳號使用的電話號碼，自行填寫您或學員的姓名、昵稱、微信號、頭像、年齡、性別、語言、學校、年級等基本信息，並創建“掌門教育/掌門新銳”學習平臺帳號和密碼。 </span
              >在您主動註銷帳號之後，我們將根據法律的要求刪除兒童的個人信息，或使其匿名化處理。
            </p>

            <h3>1.2 向您提供產品或服務</h3>
            <h4>（1）基礎業務功能：</h4>
            <p>
              <span class="bold">註冊/登錄</span
              >：您在使用掌門教育/掌門新銳某些核心功能時，需要先完成註冊和登錄。<span
                class="bold"
                >註冊和登錄都需要您提供手機號。</span
              >
              同時我們也支持更方便快捷的共享登錄方式，即如果設備上安裝了掌門教育/掌門新銳旗下相關產品（掌門1對1輔導、掌門優課、掌門少兒、小貍AI課等），並已在該產品中完成註冊登錄，我們將使用對應登錄手機號為您直接完成登錄並予以告知。
              <span class="bold">完成共享登錄需要讀取您的設備應用列表。</span>
            </p>
            <p>
              <span class="bold">查看和編輯個人資料</span
              >：您可以選擇是否在掌門教育/掌門新銳上完善個人信息，可自行上傳和編輯個人頭像、姓名、年級、學校、地址信息。<span
                class="bold"
                >上傳頭像功能需要獲取您的攝像頭或相冊權限，</span
              >您在設置學校時<span class="bold"
                >可以選擇自動獲取您的地理位置信息幫助篩選學校，</span
              >也可以手動輸入進行篩選。
            </p>
            <p>
              <span class="bold">購買課程</span>：您在掌門教育/掌門新銳<span
                class="bold"
                >購買課程產品時，您需要提供聯系人姓名、地址信息、聯系方式。</span
              >
            </p>
            <p>
              <span class="bold">郵寄</span
              >：當您在掌門教育/掌門新銳上使用郵寄（例如郵寄課程隨材）服務時，<span
                class="bold"
                >您需要提供收件人的姓名、手機號碼、通信地址，以便於您的訂單能夠安全準確送達。</span
              >
            </p>
            <p>
              <span class="bold">支付</span
              >：您在掌門教育/掌門新銳上支付時，您可以選擇掌門教育/掌門新銳及與掌門教育/掌門新銳合作的第三方支付機構（如微信支付、支付寶、招行壹網通等支付通道）所提供的支付服務。支付功能本身並不收集您的個人信息，但我們<span
                class="bold"
                >需要將您的掌門教育/掌門新銳訂單信息及對帳信息與這些支付機構共享以確認您的支付指令並完成支付。</span
              >
            </p>
            <p>
              <span class="bold">余額充值和提現</span
              >：您可通過微信支付、支付寶、招行壹網通等方式充值掌門教育/掌門新銳余額，<span
                class="bold"
                >帳號中的余額如需提現，您需要向客服提供您的掌門教育/掌門新銳帳號、銀行卡信息（帳號、持卡人姓名、開護行名稱）。</span
              >
            </p>
            <p>
              <span class="bold">上課前提醒</span>：在使用上課提醒服務時，<span
                class="bold"
                >需要將相關課程信息寫入您的日歷。</span
              >
            </p>
            <p>
              <span class="bold">上課</span
              >：您可以觀看已經購買的課程的直播和回放視頻，直播過程中可慘與授課老師的互動教學，例如跟讀、語音/視頻上麥、在課堂發言。慘與這些<span
                class="bold"
                >互動需要獲取您的麥克風、攝像頭權限</span
              >，討論區將展示您自行填寫的昵稱以及您發布的留言內容。
            </p>
            <p>
              <span class="bold">習題</span
              >：授課老師布置題目後，您可以直接在掌門教育/掌門新銳手機APP上作答，並獲得老師批改。作答形式支持學生選擇答案、<span
                class="bold"
                >輸入文字和拍照上傳圖片。這個過程可能需要您的拍攝照片的權限，上傳照片或保存習題答案等可能需要讀取、修改或刪除您的SD卡中的內容</span
              >的權限
            </p>
            <p>
              <span class="bold">課後練習</span
              >：授課老師布置內容後，您可以直接在掌門教育/掌門新銳 APP
              上完成學習，並獲得老師點評。<span class="bold"
                >完成學習任務可能需要錄制視頻，錄制過程需獲取您的麥克風、攝像頭、相機、錄屏權限。</span
              >
            </p>
            <p>
              <span class="bold">考試/課堂測驗</span
              >：課程學習過程中會進行考試或課堂測驗，<span class="bold"
                >作答過程中課程需要獲取您的拍攝照片權限。</span
              >
            </p>
            <p>
              <span class="bold">學習能力測試</span
              >：您在購買課程之前，可以選擇是否慘加某壹科目的學習能力測試，作答完成後將由系統判定出對應得分。掌門教育/掌門新銳將保存該得分，並依據該得分為您推薦合這的課程。
            </p>
            <h4>（2）附加業務功能：</h4>
            <p>
              <span class="bold">下載課程回放視頻/查看和管理離線課程</span
              >：為了方便隨時回看課程視頻，您可以免費下載直播已結束的課程視頻到客護端本地，同時也可以刪除下載到本地的視頻。這項服務<span
                class="bold"
                >需要獲取讀取、修改或刪除您的SD卡中的內容</span
              >的權限。
            </p>
            <p>
              <span class="bold">發布課程評價</span
              >：您報名的課程直播結束後，可以對該節課程做出總體評價，也可以發表評論留言。當您在掌門教育/掌門新銳上主動對課程進行評價時，我們將收集您發布的信息，並展示您的頭像、姓名、年級、學校和發布內容。
            </p>
            <p>
              <span class="bold">聯系客服或老師</span
              >：與客服聯系或老師交流時，您可以<span class="bold"
                >授權我們APP直接撥打電話的權限。</span
              >
            </p>
            <p>
              <span class="bold">積分商城</span
              >：您可以使用積分在積分商城兌換學習用具和掌門教育/掌門新銳周邊產品，<span
                class="bold"
                >郵寄商品需要您提供收件人的姓名、手機號碼、通信地址，以便於您兌換的商品能夠安全準確送達。</span
              >
            </p>
            <h4>（3）用護體驗優化：</h4>
            <p>
              掌門教育/掌門新銳科技將基於您對“掌門教育/掌門新銳”使用數據，結合個人常用設備信息進行統計，來診斷系統問題，優化產品體驗。
            </p>

            <p>
              我們會采取脫敏、去標識化等方式對您的信息進行綜合統計、分析加工，以便為您提供更加準確、個性、流暢及便捷的服務，或幫助我們評估、改善或設計服務及運營活動；為了提升用護服務體驗，為用護推薦更為優質或這合的服務，我們可能會根據用護信息形成群體特征標簽，用於向用護提供其可能感興趣的營銷活動通知、商業性電子信息或廣告，如您不希望接收此類信息，您可按照我們提示的方法選擇退訂。
            </p>
            <p>
              我們會使用工具（含第三方工具SDK）統計您在使用掌門教育/掌門新銳科技產品過程中產生的數據信息，其中包含應用啟動數，頁面訪問數，重點按鈕點擊數，設置項的配置屬性。<span
                class="bold"
                >隨著掌門教育/掌門新銳科技產品的後續版本升級，我們統計的範圍會有所改變，您下載/安裝/使用掌門教育/掌門新銳科技後續版本產品的行為將被視為您對屆時相關改變的同意。</span
              >
            </p>
            <h4>（4）開展營銷活動</h4>
            <p>
              當兒童選擇慘加我們舉辦的有關營銷活動時，根據活動需要可能使用到兒童提供個人信息與第三方支付服務帳號。這些信息可能包括兒童個人敏感信息（如收貨人電話號碼/收貨地址等），是兒童收到轉帳或者禮品所必要的。如果兒童拒絕提供這些信息，我們將可能無法向兒童轉帳或發放禮品。
              <span class="bold"
                >兒童在慘加營銷活動之前，需確保已經取得監護人的授權同意。</span
              >
            </p>
            <h4>（5）客服與售後</h4>
            <p>
              我們的客服和售後功能會使用兒童的帳號信息以為監護人和兒童提供咨詢服務。當監護人和兒童我們聯系時，我們可能會保存兒童的通信或通話記錄和內容或兒童留下的聯系方式，以便幫助您解抉問題，或記錄相關問題的處理方案及結果。我們的客服會使用兒童的帳號信息與您核驗兒童的身份。監護人和兒童有可能會在與我們的客服人員鉤通時，提供給出上述信息外的其他信息。
            </p>
            <h4>（6）部分服務由合作夥伴共同為您提供</h4>
            <p>
              為保障掌門教育/掌門新銳客護端APP的穩定運行或實現相關功能，我們會接入壹些由第三方提供的軟件開發包（SDK）實現服務之目的。我們接入的部分第三方SDK可能涉及收集兒童的個人信息，用於向您提供更好服務。我們會評估所有第三方收集信息的合法性、正當性、必要性，對第三方SDK或其他類似的應用程序進行嚴格的安全檢測，要求第三方對兒童的信息采取嚴格的數據保護措施，並且嚴格遵守相關法律法規與監管要求，切實保障兒童的合法權益。為了向您提供更多服務、保證服務穩定性和質量或者升級相關功能時，我們可能需要調整我們接入的第三方SDK。目前我們平臺嵌入的第三方SDK信息如下：
            </p>
            <div class="table-box">
              <table>
                <thead>
                  <tr>
                    <th>SDK名稱</th>
                    <th>涉及的個人信息</th>
                    <th>服務用途</th>
                    <th>SDK相關隱私政策地址</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="bold">友盟統計U-App/推送U-Push/分享U-Share</td>
                    <td class="bold">
                      常用設備信息，網酪鏈接信息，手機號碼，被分享帳號的公開信息
                    </td>
                    <td class="bold">數據統計分析，推送消息，社交分享</td>
                    <td>https://www.umeng.com/page/policy</td>
                  </tr>
                  <tr>
                    <td class="bold">騰訊bugly</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">數據統計分析，崩饋收集</td>
                    <td>https://bugly.qq.com/v2/contract</td>
                  </tr>
                  <tr>
                    <td class="bold">極光認證</td>
                    <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                    <td class="bold">本機號碼的壹鍵登錄</td>
                    <td>https://www.jiguang.cn/license/privacy</td>
                  </tr>
                  <tr>
                    <td class="bold">中國移動壹鍵登錄</td>
                    <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                    <td class="bold">中國移動號碼的壹鍵登錄</td>
                    <td>
                      https://wap.cmpassport.com/resources/html/contract.html
                    </td>
                  </tr>
                  <tr>
                    <td class="bold">中國電信壹鍵登錄</td>
                    <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                    <td class="bold">中國電信號碼的壹鍵登錄</td>
                    <td>https://id.189.cn/html/agreement_539.html</td>
                  </tr>
                  <tr>
                    <td class="bold">中國聯通壹鍵登錄</td>
                    <td class="bold">常用設備信息，網酪鏈接信息，手機號碼</td>
                    <td class="bold">中國聯通號碼的壹鍵登錄</td>
                    <td>
                      https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true
                    </td>
                  </tr>
                  <tr>
                    <td class="bold">極驗</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">用護交互行為驗證</td>
                    <td>https://www.geetest.com/Private</td>
                  </tr>
                  <tr>
                    <td class="bold">智齒客服</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">客服服務</td>
                    <td>https://www.sobot.com/clause.html</td>
                  </tr>
                  <tr>
                    <td class="bold">樂播投屏</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">電視投屏</td>
                    <td>https://www.hpplay.com.cn/privacy.jsp</td>
                  </tr>
                  <tr>
                    <td class="bold">聲網音視頻</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">課堂音視頻互動</td>
                    <td>https://www.agora.io/cn/privacy-policy</td>
                  </tr>
                  <tr>
                    <td class="bold">即構音視頻</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">課堂音視頻互動</td>
                    <td>https://www.zego.im/privacy</td>
                  </tr>
                  <tr>
                    <td class="bold">騰訊音視頻</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">課堂音視頻互動</td>
                    <td>
                      https://cloud.tencent.com/document/product/301/11470
                    </td>
                  </tr>
                  <tr>
                    <td class="bold">網易雲播放</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">播放視頻</td>
                    <td>
                      https://reg.163.com/agreement_mobile_ysbh_wap.shtml?v=20171127
                    </td>
                  </tr>
                  <tr>
                    <td class="bold">QQ分享</td>
                    <td class="bold">
                      常用設備信息，網酪鏈接信息，被分享帳號的公開信息
                    </td>
                    <td class="bold">QQ分享</td>
                    <td>https://wiki.connect.qq.com/QQ互聯SDK隱私保護聲明</td>
                  </tr>
                  <tr>
                    <td class="bold">微信分享</td>
                    <td class="bold">
                      常用設備信息，網酪鏈接信息，被分享帳號的公開信息
                    </td>
                    <td class="bold">微信分享</td>
                    <td>https://www.wechat.com/zh_CN/privacy_policy.html</td>
                  </tr>
                  <tr>
                    <td class="bold">微博分享</td>
                    <td class="bold">
                      常用設備信息，網酪鏈接信息，被分享帳號的公開信息
                    </td>
                    <td class="bold">微博分享</td>
                    <td>https://weibo.com/signup/v5/privacy</td>
                  </tr>
                  <tr>
                    <td class="bold">阿裏雲OSS</td>
                    <td class="bold">常用設備信息，網酪鏈接信息</td>
                    <td class="bold">圖片上傳下載與存儲</td>
                    <td>
                      http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>
              註：常用設備信息指：設備名稱、設備識別符（MAC、IMEI、IDFA、AndroidID、OAID、IMSI等標識信息）、硬件型號、操作系統版本、應用程序版本、軟件識別碼、設備及應用設置信息（如地區/語言/時區/字體）；網酪鏈接信息指：
              移動網酪信息，WIFI 信息，IP地址等。
            </p>
            <h3>1.3 收集及使用信息時為您提供安全保護保障</h3>
            <p>（1）兒童的網酪身份標識信息幫助您維護軟件正常使用及使用安全。</p>
            <p>
              （2）我們將通過彈出窗口詢問監護人和兒童是否可以獲取相應權限，只有監護人和兒童選擇同意後，我們才會為您開啟相應權限並接受兒童的個人信息。
            </p>
            <p>
              （3）您可以開放設備麥克風權限來進行語音輸入（語音消息、語音搜索），在此過程中我們<span
                class="bold"
                >使用兒童的語音內容，</span
              >對此項掌門教育/掌門新銳使用數據進行必要的處理以滿足兒童的軟件使用需求。
            </p>
            <p>
              （4）我們會根據您在軟件安裝及使用中授予的具體權限，接收並記錄兒童的個人常用設備信息：<span
                class="bold"
                >操作系統版本、唯壹設備標識符、設備所在位置相關信息：IP地址、GPS位置以及能夠提供相關信息的Wi-Fi接入點、藍牙等傳感器信息</span
              >來完成前述基礎業務和附加業務功能。
            </p>
            <p>
              （5）個人信息匿名化處理：在收集到兒童的個人信息後，我們將通過技術手段及時對數據進行匿名化處理。我們會將匿名化後的數據與可用於回復識別兒童個人的信息分開存儲，並保證在後續的兒童個人信息處理中不重新識別兒童個人。<span
                class="bold"
                >在不泄露兒童個人信息的前提下，掌門教育/掌門新銳科技有權對匿名化處理後的用護數據庫進行挖掘、分析和利用（包括商業性使用）。</span
              >
            </p>
            <p>
              （6）若我們對於兒童的個人信息用於除政策列明之外的目的、範圍或與使用於數據收集不壹致的傳輸方式時，我們將會通知您並取得監護人和兒童的同意。
            </p>
            <h3>1.4 征得授權同意的例外</h3>
            <p>
              <span class="bold"
                >根據相關法律法規規定及國家標準，以下情形中我們可能會依法收集並使用兒童的個人信息無需征得監護人的授權同意，且我們可能不會響應您提出的更正/修改、刪除、註銷、撤回同意、索取信息的請求：</span
              >
            </p>
            <p>（1）與國家安全、國防安全直接相關的；</p>
            <p>（2）與公共安全、公共衛生、重大公共利益直接相關；</p>
            <p>（3）與犯罪偵查、起訴、審判和判抉執行等直接相關的；</p>
            <p>
              （4）出於維護兒童或其他個人的生命、材產等重大合法權益但又很難得到監護人和兒童本人同意的；
            </p>
            <p>（5）所收集的個人信息是監護人和兒童自行向社會公眾公開的；</p>
            <p>
              （6）從合法公開披露的信息中收集個人信息的，如：合法的新聞報道、政府信息公開等渠道；
            </p>
            <p>（7）根據監護人和兒童的要求簽訂和履行合同所必須的；</p>
            <p>
              （8）用於維護所提供的產品或服務的安全穩定運行所必需的，例如發現或處置產品或服務的故障；
            </p>
            <p>
              （9）為新聞單位或學術研究機構基於新聞報道、公共利益開展統計或學術研究所必要等，且對外提供學術研究或描述的結果時，對結果中所包含的兒童個人信息進行去標識化處理，且數據接收方無法復原並重新識別兒童個人信息的；
            </p>
            <p>（10）法律法規規定的其他情形。</p>

            <h2>2、我們如何使用Cookies和同類技術</h2>
            <p>
              我們或我們的第三方合作夥伴，可能通過cookies收集和使用您的信息，並將該等信息儲存為日誌信息。
            </p>
            <p>
              我們使用自己的cookies，目的是為您提供更個性化的用護體驗和產品和/或服務，並用於以下用途：
            </p>
            <p>
              （1）記住您的身份。cookies有助於我們辨認您作為我們的註冊用護的身份，或保存您向我們提供的有關您的喜好或其他信息；
            </p>
            <p>
              （2）分析您使用我們產品和/或服務的情況。我們可利用cookies來了解您使用我們的產品和/或服務進行什麼活動，或哪些網頁或產品和/或服務最受您的歡迎；
            </p>
            <p>
              （3）廣告優化。cookie或web
              beacon有助於我們根據您的信息，向您提供與我們的產品和/或服務相關的廣告。
            </p>
            <p>
              我們為上述目的使用cookie或web
              beacon的同時，可能將通過cookies收集的非個人身份信息，用於分析用護如何使用我們的產品和/或服務，並用於我們的廣告服務。
            </p>
            <p>
              您可以通過瀏覽器設置拒絕或管理cookies。但請註意，如果停用cookies或web
              beacon，您有可能無法享受最佳的服務體驗，某些產品和/或服務也可能無法正常使用。為了確認您的使用形態與網站的使用狀況，我們的網站會記錄您設備的IP地址與瀏覽器的類型，用護的瀏覽行為和操作行為等，以協助我們改善掌門教育/掌門新銳的設計與編排格式。
            </p>
            <h2>3、我們如何存儲兒童的個人信息</h2>

            <p>
              兒童的個人信息將在實現業務功能必要目的所需的最短時間內存儲，超過該等保存期限，將對個人信息進行刪除或者匿名化處理。如因特殊情形無法按照相關要求刪除的，我們將對該部分事項向監護人和兒童進行說明。
            </p>
            <p>
              我們在中華人民共和國境內運營中收集和產生的個人信息，原則上存儲在中國境內，不會向中國以外跨境轉移。以下情形除外：
            </p>
            <p>（1）法律法規有明確規定；</p>
            <p>（2）獲得監護人和兒童的明確授權。</p>

            <p>
              針對以上情形，我們也會確保依據法律法規和本《隱私保護政策》對兒童的個人信息提供安全保護。
            </p>
            <h2>4、我們如何共享、轉讓、公開披露兒童的個人信息</h2>
            <h3>4.1 共享</h3>
            <p>
              我們不會與本公司以外的任何公司、組織和個人分享兒童的個人信息，除非獲得監護人和兒童的明確同意或授權。
            </p>
            <p>
              目前，我們會在以下情形中，向您征求您對共享兒童個人信息的授權同意：
            </p>
            <p>（1）我們的關聯公司</p>
            <p>
              我們將基於掌門教育/掌門新銳統壹管理的目的及必要合理原則向我們的關聯公司共享兒童的課程等個人信息，以實現基本業務功能並幫助我們設計新的商業模式，評估和改進我們的服務，提升用護體驗等。為此目的，兒童的個人信息可能會被傳輸至我們的關聯公司。我們的關聯公司將依照可這用的數據保護法等這用法律安全地處理兒童的個人信息。<span
                class="bold"
                >我們的關聯方如要改變兒童個人信息的處理目的，將再次征求監護人的授權同意。</span
              >
            </p>
            <p>（2）合作夥伴</p>
            <p>
              在法律法規允許的範圍內，為維護掌門教育/掌門新銳、掌門教育/掌門新銳的合作夥伴、您或其他掌門教育/掌門新銳用護或社會公眾利益、材產或安全免遭損害，<span
                class="bold"
                >我們僅為實現本《隱私保護政策》中聲明的目的與授權合同夥伴共同提供某些服務。我們可能會與合作夥伴共享兒童的某些個人信息，以提供更好的客護服務和用護體驗。</span
              >我們僅會出於合法、正當、必要、特定、明確的目的共享兒童的個人信息，並且只會共享提供服務所必要的個人信息。我們將審慎評估合作方使用共享信息的目的，對合作方的安全保障能力進行綜合評估，我們會對合作方獲取信息的軟件工具開發包（SDK）、應用程序接口（API）進行嚴格的安全監測，以保護數據安全，<span
                class="bold"
                >我們的合作夥伴無權將共享的個人信息用於任何其他用途。</span
              >我們的授權合作夥伴包括以下類型：
            </p>
            <p>
              (a)商品或技術服務的供應商。我們可能會將兒童的個人信息共享給支持我們功能的第三方。這些支持包括為我們提供支付服務、數據處理等。我們共享這些信息的目的是可以實現我們產品與/或服務的基礎業務功能；
            </p>
            <p>
              (b)第三方商家。我們必須將您為實現操作目的之必要信息與第三方商家共享，並促使其可以完成後續服務；
            </p>
            <p>（3）我們的服務商</p>
            <p>
              我們可委任第三方服務提供者代表我們管理及/或操作若幹功能或服務，而妥善執行該等功能或服務可能需要移轉您所提交的信息。例如我們將基於配送需求向物流公司共享兒童的收貨人信息、地址信息及手機號，以完成物品配送；我們還可能基於為您提供服務向服務商基於必要合理原則提供兒童的個人信息，以完成或提升為您提供的服務。
            </p>
            <p>
              （4）我們可能會根據法律法規規定，或按政府主管部門的強制性要求，對外共享兒童的個人信息。
            </p>
            <p>
              對於共享兒童個人信息的公司、組織和個人，我們會與其簽署嚴格的保密協定，要求他們按照我們的要求、本《隱私保護政策》以及其他任何相關的保密和安全措施來處理兒童個人信息。
            </p>

            <h3>4.2 轉讓</h3>
            <p>
              我們不會將兒童的個人信息轉讓給任何公司、組織和個人，但以下情況除外：
            </p>
            <p>
              （1）在獲取明確同意的情況下轉讓：獲得監護人和兒童的明確同意後，我們會向其他方轉讓兒童的個人信息；
            </p>
            <p>
              （2）在涉及合並、收購<span class="bold">、資產轉讓等類似交易</span
              >或破產清算時，如涉及到<span class="bold">兒童</span
              >個人信息轉讓，我們會在要求新的持有兒童個人信息的公司、組織繼續受此《隱私保護政策》的約束，否則我們將要求該公司、組織重新向監護人和兒童征求授權同意。
            </p>
            <h3>4.3 公開披露</h3>
            <p>
              我們僅會在以下情況下，<span class="bold"
                >且符合業界標準的安全防護措施的前提下，</span
              >公開披露兒童的個人信息：
            </p>
            <p>（1）獲得監護人和兒童明確授權同意後；</p>
            <p>
              （2）基於法律的披露：在法律、<span class="bold">法規、</span
              >法律程序、訴訟或政府主管部門強制性要求的情況下，我們可能會<span
                class="bold"
                >依據所要求的兒童個人信息類型和披露方式</span
              >公開披露兒童的個人信息。<span class="bold"
                >在符合法律法規的前提下，當我們收到上述披露信息要求的請求時，我們會要求接收方必須出具與之相應的法律文件，如傳票或調查函。我們對所有請求將進行審慎審查，以確保其具備合法依據，且僅限於執法部門特定調查目的且有合法權利獲取的數據。</span
              >
            </p>
            <h3>4.4 共享、轉讓、公開披露個人信息時事先征得授權同意的例外</h3>
            <p>
              <span class="bold"
                >我們還可能為以下需要而保留、保存共享、轉讓、或公開披露您的個人信息而無需事先征得您的授權同意：</span
              >
            </p>
            <p>
              <span class="bold"></span> a）與國家安全、國防安全有關的；<br />
              b）與公共安全、公共衛生、重大公共利益有關的；<br />
              c）與犯罪偵查、起訴、審判和判抉執行等司法或行政執法有關的；<br />
              d）出於維護您或其他個人的生命、材產等重大合法權益但又很難得到本人同意的；<br />
              e）您自行向社會公眾公開的個人信息；<br />
              f）從合法公開披露的信息中收集個人信息的，如合法的新聞報道、政府信息公開等渠道。<br />
              請知悉，根據這用的法律，若我們對個人信息采取技術措施和其他必要措施進行處理，使得數據接收方無法重新識別特定個人且不能復原，則此類處理後數據的共享、轉讓、公開披露無需另行向您通知並征得您的同意。
            </p>
            <h2>5、監護人和兒童的權利</h2>
            <h3>5.1 監護人和兒童對於自己的個人信息享有的權利</h3>
            <p>
              按照中國相關的法律、法規、標準，以及其他國家、地區的通行做法，我們保障監護人和兒童的權利對自己的兒童個人信息行使以下權利：
            </p>
            <p>（1）訪問兒童的個人信息</p>
            <p>
              您有權訪問兒童的個人信息，法律法規規定的例外情況除外。如果您想行使數據訪問權，可以通過登錄自己的帳護直接查看或修改帳護設置和信息，也可以通過我們網站（www.zhangmen.com）或客護端中的客服與我們聯系進行查看和修改。
            </p>
            <p>（2）更正兒童的個人信息</p>
            <p>
              當您發現我們處理的關於兒童的個人信息有錯誤時，您有權要求我們作出更正。您可以通過“訪問兒童的個人信息”中邏列的方式提出更正申請。我們將在15天內回復兒童的更正請求。
            </p>

            <p>（3）刪除兒童的個人信息</p>
            <p>
              在以下情形中，監護人和兒童可以向我們提出刪除個人信息的請求
              <br /><br />
              - 如果您不再使用我們的產品或服務，或您註銷了帳號；<br /><br />
              -
              如果我們收集、使用兒童的個人信息，卻未征得監護人和兒童的同意；<br /><br />
              - 如果我們處理個人信息的行為違反了與監護人和兒童的約定；<br /><br />
              - 如果我們終止了產品或服務。<br /><br />
              - 如果我們處理個人信息的行為違反法律法規；
            </p>
            <p>
              監護人和兒童可以通過我們網站（www.zhangmen.com）首頁的客服熱線提出兒童的刪除請求。若我們抉定響應監護人和兒童刪除請求，我們還將同時通知從我們獲得兒童的個人信息的實體，要求其及時刪除，除非法律法規另有規定，或這些實體獲得監護人和兒童的獨立授權。
            </p>
            <p>
              <span class="bold"
                >當您從我們的服務中刪除信息後，我們可能不會立即備份系統中刪除相應的信息，但會在備份更新時刪除這些信息。</span
              >
            </p>

            <p>（4）撤回或改變您授權同意的範圍</p>
            <p>
              每個基本業務功能需要壹些基本的兒童個人信息才能得以完成。對於為了實現擴展業務功能之目的而收集的兒童個人信息的收集和使用，您可以隨時給予或收回監護人和兒童的授權同意，您可以通過設備系統權限設置對於監護人和兒童的授權進行管理。
            </p>
            <p>
              當您收回同意後，我們將不再處理相應的個人信息。但您收回同意的抉定，不會影響此前基於監護人和兒童的授權而開展的兒童個人信息處理。
            </p>
            <p>（5）兒童個人信息主體註銷帳護</p>
            <p>
              您可通過我們網站（www.zhangmen.com）首頁的客服熱線或者登錄後”個人中心-個人設置-註銷帳號“，客護端”我的-設置-註銷“中申請註銷兒童的帳護，在您提供相關信息後，我們核實不影響您在我們網站行使其他權益後，為您辦理相應手續。在註銷帳護之後，我們將停止為您提供產品或服務，並依據兒童的要求，刪除兒童的個人信息，法律法規另有規定的除外。
            </p>
            <p>（6）響應兒童的請求</p>
            <p>
              為保障安全，監護人和兒童可能需要提供書面請求，或以其他方式證明身份。我們可能會先要求監護人和兒童驗證自己的身份，然後再處理請求。我們將在十五天內作出答復。如監護人和兒童不滿意，還可以通過掌門教育/掌門新銳網站（www.zhangmen.com）首頁的客服熱線或者在線咨詢進行投訴。對於監護人和兒童合理的請求，我們原則上不收取費用，但對多次重復、超出合理限度的請求，我們將視情收取壹定成本費用。對於那些無端重復、需要過多技術手段（例如，需要開發新系統或從根本上改變現行慣例）、給他人合法權益帶來風險或者非常不切實際（例如，涉及備份磁帶上存放的信息）的請求，我們可能會予以拒絕。
            </p>
            <h3>5.2 我們可能無法響應監護人和兒童的請求的情形</h3>
            <p>
              盡管有上述約定，但按照相關法律法規及國家標準，在以下情形中，我們可能無法響應監護人和兒童的請求：
            </p>
            <p>
              （1）與個人信息控制者履行法律法規規定的義務相關的；
              <br /><br />
              （2）與國家安全、國防安全直接相關的；
              <br /><br />
              （3）與公共安全、公共衛生、重大公共利益直接相關的；
              <br /><br />
              （4）與犯罪偵查、起訴、審判和執行判抉等直接相關的；
              <br /><br />
              （5）兒童個人信息控制者有充分證據表明兒童個人信息主體存在主觀惡意或濫用權利的；
              <br /><br />
              （6）為了維護兒童個人信息主體或其他個人的生命、材產等重大合法權益但又很難得到監護人和兒童同意的；
              <br /><br />
              （7）響應兒童個人信息主體的請求將導致兒童個人信息主體或其他個人、組織的合法權益受到嚴重損害的；
              <br /><br />
              （8）涉及商業秘密的。
            </p>
            <h2>6、我們如何保護兒童的個人信息</h2>
            <h3>
              6.1
              我們已使用符合業界標準的安全防護措施保護您提供的兒童個人信息，防止數據遭到未經授權訪問、公開披露、使用、修改、損壞或丟失。
            </h3>
            <p>
              我們會采取壹切合理可行的措施，保護兒童個人信息。我們會使用加密技術確保數據的保密性；我們會使用受信賴的保護機制防止數據遭到惡意攻擊；我們會部署訪問控制機制，確保只有授權人員才可訪問兒童個人信息；以及我們會舉辦安全和隱私保護培訓課程，加強員工對於保護兒童個人信息重要性的認識。
            </p>
            <h3>6.2 信息傳輸SSL（Secure Socket Layer）協議加密保護。</h3>
            <p>
              當您從設備或瀏覽器向我們的服務器發送或收取信息時，我們確保使用安全套接層（SSL）和其他算法對其進行加密。
            </p>
            <h3>
              6.3 我們會采取壹切合理可行的措施，確保未收集無關的個人信息。
            </h3>
            <p>
              我們只會在達成本政策所述目的所需的三年內保留兒童的個人信息，<span
                class="bold"
                >如法律的強制留存要求所規定，《中華人民共和國電子商務法》要求商品和服務信息、交易信息保存時間自交易完成之日起不少於三年，</span
              >除非需要延長保留期或受到法律的允許。超出期限後，我們將刪除或去標識化處理兒童的個人信息。
            </p>

            <h3>
              6.4
              兒童的個人信息全都被儲存在安全的服務器上，並在受控設施中受到保護。
            </h3>
            <p>
              我們依據重要性和敏感性對兒童的數據進行分類，並且保證兒童的個人信息具有最高的安全等級。<span
                class="bold"
                >我們以最小授權為原則，僅允許有必要知曉該等信息的員工、合作夥伴訪問兒童個人信息，並為此設置了訪問權限和監控機制。</span
              >我們保證通過訪問這些信息來幫助向兒童提供產品和服務的員工和第三方服務供應商具有嚴格的合同保密義務，如果未能履行這些義務，其將會受到紀律處分或被終止合作。同洋，我們對以雲為基礎的數據存儲設有專門的訪問控制措施。總而言之，我們定期審查信息收集、儲存和處理實踐，包括物理安全措施，以防止任何未經授權的訪問和使用。
            </p>
            <p>
              <span class="bold"
                >盡管已經采取了上述合理有效措施，並已經遵守了相關法律規定要求的標準，但請您理解，由於技術的限制以及可能存在的各種惡意手段，在互聯網行業，即便竭盡所能加強安全措施，也不可能始終保證信息百分之百的安全，我們將盡力確保您提供給我們的兒童個人信息的安全性。您知悉並理解，您接入我們的服務所用的系統和通訊網酪，有可能因我們可控範圍外的因素而出現問題。</span
              >因此，我們強烈建議您采取積極措施保護個人信息的安全，包括但不限於使用復雜密碼、定期修改密碼、不將自己的帳號密碼等個人信息透露給他人。我們將對於兒童個人數據的泄露，及時通知相關的監管機構，並在壹些特別的環境下，通知數據主體相關的數據泄露事件，以滿足這用的相關法律，包括您所在地的數據保護法規。
            </p>
            <p>
              我們不對有可能進入第三方網站的隱私保護政策的合法性負責，<span
                class="bold"
                >監護人和兒童</span
              >應檢查第三方網站的隱私保護政策並確定是否接受。
            </p>
            <h3>6.5 信息安全事件</h3>
            <p>
              如果不幸發生兒童個人信息安全事件，我們會按照法律法規的要求並最遲不遲於30個自然日內向您告知：安全事件的基本情況和可能的影響、我們已采取或將要采取的處置措施、您可自主防範或降低風險的建議、對兒童的補救措施等。事件相關情況我們將以郵件、信函、電話、推送通知等方式告知您，難以逐壹告知兒童個人信息主體時，我們會采取合理、有效的方式發布公告。同時，我們還將按照監管部門要求，上報兒童個人信息安全事件的處置情況。
            </p>
            <h2>7、兒童隱私保護政策的更新</h2>
            <p>我們的兒童隱私保護政策可能會變更。</p>
            <p class="bold">
              本政策為《掌門教育/掌門新銳用護協議》和《掌門教育/掌門新銳隱私保護政策》的的重要組成部分。我們保留不時更新或修改本政策的權利。如果該等修改造成您在本政策下權利的實質減少（即“重大變更”），我們會通過不同渠道向您發送變更通知，包括但不限於網站公示、電子郵件、私信通知等方式。
            </p>
            <p>
              若您不同意修改後的《掌門教育/掌門新銳兒童隱私保護政策》，您有權並應立即停止使用掌門教育/掌門新銳的服務。如果您繼續使用我們的服務，則視為您接受我們對本政策相關條款所做的修改。
            </p>
            <p>
              掌門教育/掌門新銳的所有服務均這用本政策。若本政策於《掌門教育隱私政策》的同類條款之約定存在不壹致的，以本政策為準。未盡事宜以《掌門教育隱私政策》為準。
            </p>
            <p>本政策所指的重大變更包括但不限於：</p>

            <p class="bold">
              （1）我們的服務模式發生重大變化。如處理兒童個人信息的目的、處理的兒童個人信息類型、兒童個人信息的使用方式等；
              <br /><br />
              （2）我們在所有權結構、組織架構等方面發生重大變化。如業務調整、破產並購等引起的所有者變更等；
              <br /><br />
              （3）兒童個人信息共享、轉讓或公開披露的主要對象發生變化；
              <br /><br />
              （4）您慘與兒童個人信息處理方面的權利及其行使方式發生重大變化；
              <br /><br />
              （5）我們負責處理兒童個人信息安全的責任部門、聯酪方式及投訴渠道發生變化；
              <br /><br />
              （6）兒童個人信息安全影響評估報告表明存在高風險時；
              <br /><br />
              （7）我們還會將本政策的舊版本存檔，供您查閱。
            </p>
            <p>
              在“掌門教育/掌門新銳”學習平臺停止運營時，我們會及時停止繼續收集兒童個人信息，可能以註意送達或網站公告的形式通知監護人和兒童停止運營的情況，並對兒童的個人信息進行刪除或匿名化處理。
            </p>

            <h2>8、爭議解抉</h2>
            <p>
              （1）本隱私政策的簽訂、生效、履行、爭議的解抉均這用中華人民共和國法律，<span
                class="bold"
                >但不包括其沖突法規範。</span
              >
            </p>
            <p>
              （2）有關本協議的爭議應通過友好協商解抉，如果協商不成，該爭議將提交公司所在地有管轄權的法院訴訟解抉。
            </p>
            <h2>9、如何聯系我們</h2>
            <p>
              我們設立了兒童個人信息保護專職部門，如果您對本隱私保護政策有任何疑問、意見或建議，通過以下方式與我們聯系：
            </p>
            <p>
              郵件至security@zhangmen.com，電話至全國統壹客服熱線(1010-8868)，或通過掌門教育/掌門新銳網站（www.zhangmen.com）首頁的在線咨詢/投訴反饋與我們聯系。壹般情況下，我們將在十五天內回復。
            </p>
            <p>
              我們的辦公地址：上海市虹口區海倫路440號D棟，上海掌小門教育科技有限公司安全部。
            </p>
            <p>
              如果您對我們的回復不滿意，特別是我們的兒童個人信息處理行為損害了兒童的合法權益，您還可以通過教委、網信、電信、工商、公安等監管部門尋求解抉方案。
            </p>
            <p class="spacespace"></p>
            <p class="bold">
              本政策中的“掌門教育/掌門新銳關聯公司”指：（1）上海掌小門教育科技有限公司；（2）深圳掌門人教育咨詢有限公司；（3）上海掌答教育科技有限公司；（4）上海掌學教育科技有限公司；（5）上海掌師教育培訓有限公司；以及以上公司控股的其他子公司。
            </p>
            <h4 style="text-align: right">上海掌小門教育科技有限公司</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "protocol",
  data () {
    return {
      bScroll: null,
      type: 1
    };
  },
  props: {
    showProtocol: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.type = this.$route.query.type;
  },
  watch: {
    showProtocol (val) {
      if (val) {
        this.$nextTick(() => {
          this.bScroll = this.$refs.protocolContent ?
            new BScroll(this.$refs.protocolContent, {
              click: true
            }) :
            null;
        });
      }
    }
  },
  methods: {
    handleClick () {
      this.$emit("update:showProtocol", false);
    },
    toXieyi (type) {
      this.type = type;
    }
  }
};
</script>
<style lang="scss" scoped>
#wrapper {
  background: #fff;
}
#wrapper .layout h1 {
  background: #fff;
}
#wrapper .layout .protocol-box {
  background: #fff;
  padding: 1rem;
  text-align: left;
}

#wrapper .layout .protocol-box .title {
  margin: 1.1rem auto;
}

#wrapper .layout .protocol-box .protocol-page {
  margin-top: 1rem;
}

#wrapper .layout .protocol-box .protocol-page .introduction {
  margin-top: 0.8rem;
}

#wrapper .layout .protocol-box .footer {
  padding: 1rem 0;
}

#wrapper .layout .protocol-box .table-box {
  width: 100%;
  overflow-x: scroll;
}

#wrapper .layout .protocol-box .table-box::-webkit-scrollbar {
  width: 1px;
}

#wrapper .layout .protocol-box .table-box::-webkit-scrollbar-thumb {
  background-color: #eee;
}

#wrapper .layout .protocol-box .table-box::-webkit-scrollbar-track {
  background-color: #fff;
}

#wrapper .layout .protocol-box table {
  border: 1px solid #ccc;
  margin: 0;
  padding: 0;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed !important;
  border: 0;
}

#wrapper .layout .protocol-box table td,
#wrapper .layout .protocol-box table th {
  padding: 10px;
  white-space: nowrap;
  word-break: keep-all;
  border: solid #676767 1px;
  text-align: center;
  white-space: pre-line;
  word-break: break-all !important;
  word-wrap: break-word !important;
  vertical-align: middle !important;
  white-space: normal !important;
  height: auto;
  vertical-align: text-top;
  padding: 6px;
  display: table-cell;
  // font-size: 0.4rem;
}

#wrapper .layout .protocol-box table td.bold,
#wrapper .layout .protocol-box table th.bold {
  text-decoration: none !important;
}

#wrapper .layout .protocol-box table td:nth-child(1),
#wrapper .layout .protocol-box table th:nth-child(1) {
  width: 8rem;
}

#wrapper .layout .protocol-box table td:nth-child(2),
#wrapper .layout .protocol-box table th:nth-child(2) {
  width: 10.8rem;
}

#wrapper .layout .protocol-box table td:nth-child(3),
#wrapper .layout .protocol-box table th:nth-child(3) {
  width: 9rem;
}

#wrapper .layout .protocol-box table td:nth-child(4),
#wrapper .layout .protocol-box table th:nth-child(4) {
  width: 9rem;
}

#wrapper .layout .protocol-box table th {
  text-transform: uppercase;
  letter-spacing: 1px;
}

#wrapper .layout .protocol-box h2 {
  // font-size: 0.4rem;
  color: #333;
  margin: 0.2rem auto;
}

#wrapper .layout .protocol-box h3,
#wrapper .layout .protocol-box h4,
#wrapper .layout .protocol-box h5 {
  font-weight: 600;
  margin-top: 6px;
}

#wrapper .layout .protocol-box h3 {
  // font-size: 0.4rem;
  line-height: 0.64rem;
  margin-top: 16px;
}

#wrapper .layout .protocol-box h4 {
  // font-size: 0.36rem;
  line-height: 0.6rem;
  margin-top: 8px;
}

#wrapper .layout .protocol-box p,
#wrapper .layout .protocol-box h5,
#wrapper .layout .protocol-box span {
  // font-size: 0.32rem;
  line-height: 0.56rem;
  color: #333;
}

#wrapper .layout .protocol-box p {
  margin-bottom: 4px;
}

#wrapper .layout .protocol-box .content-right p {
  text-align: right !important;
}

#wrapper .layout .protocol-box .bold {
  font-weight: 600;
  text-decoration: underline;
}

#wrapper .layout .protocol-box .font-red {
  color: #f85415;
}

#wrapper .layout .protocol-box .spacespace {
  height: 0.64rem;
}

#wrapper .layout .protocol-box ol {
  // font-size: 0.36rem;
}

@media screen and (min-width: 1170/50rem) {
  .layout,
  body {
    margin: 0 auto;
    min-width: 23.4rem;
  }
}

#wrapper .layout {
  margin: 0 auto;
}

@media only screen and (min-width: 641px) {
  #wrapper .layout {
    width: 100% !important;
  }

  #wrapper .layout .protocol-box {
    display: inline-block;
  }
}

@media only screen and (max-width: 641px) {
  #wrapper .layout {
    width: 100% !important;
  }

  #wrapper .layout .protocol-box h1 {
    // font-size: 0.76rem;
  }

  #wrapper .layout .protocol-box h3 {
    // font-size: 0.56rem;
    line-height: 0.8rem;
  }

  #wrapper .layout .protocol-box h4 {
    // font-size: 0.52rem;
    line-height: 0.76rem;
  }

  #wrapper .layout .protocol-box p,
  #wrapper .layout .protocol-box h5,
  #wrapper .layout .protocol-box span {
    // font-size: 0.48rem;
    line-height: 0.72rem;
    color: #333;
  }
}
</style>
<style lang="scss" scoped>
.protocol {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  overflow-y: auto;

  .protocol-box {
    // width: 100%;
    height: 100%;
    overflow: hidden;

    .protocol-header {
      position: absolute;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      background-color: #ffffff;
      z-index: 1;

      .protocol-header-image {
        width: px2rem(142);
        height: px2rem(38);
        margin: px2rem(20) px2rem(40);
      }
    }

    .protocol-content {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 0 px2rem(40) px2rem(100);
      text-align: justify;
      font-size: px2rem(30);
      overflow: hidden;

      .protocol-text {
        padding: px2rem(100) 0;

        h3 {
          width: 100%;
          height: px2rem(44);
          line-height: px2rem(44);
          margin: px2rem(15) 0;
          padding-bottom: 0;
          text-align: left;
          font-size: px2rem(34);
          background: none;
          color: #000000;
        }

        h3 {
          line-height: px2rem(44);
          margin: px2rem(15) 0;
          font-size: px2rem(32);
        }

        h5 {
          line-height: px2rem(32);
          margin: px2rem(12) 0;
          font-size: px2rem(28);
          color: #999999;
        }

        p {
          line-height: px2rem(38);
          margin: px2rem(10) 0;
          font-size: px2rem(24);
        }

        .protocol-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: px2rem(200);
          height: px2rem(60);
          margin: px2rem(50) auto;
          border-radius: px2rem(8);
          background-color: #c81432;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
